

/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import customStyles from "../../../../../assets/styles/customStyles";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import MainHeader from "../../../../Shared/components/Header";
import { useParams, NavLink } from "react-router-dom";
import { Col, Image, Row, Space, Modal } from "antd";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import {
    Switch, FormControl, RadioGroup, Radio, FormControlLabel, Checkbox, Button, InputLabel, TextField, Box, TableContainer, Table, TableHead, TableCell, TableRow, InputAdornment, Tooltip, IconButton, Tab, Typography
} from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import DateIcon from "../../../../Shared/components/Icons/Date";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useDispatch, useSelector } from "react-redux";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import actions from "../../redux/actions";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity, customEmailValidation, stringLengthOptionalValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import addressActions from "../../../../Admin/Address/redux/actions";
import productActions from "../../../../Product/Product/redux/actions";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import InfoMark from "../../../../../assets/images/icon_actions/infoMark.svg";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import InvoiceModal from "../../../../Shared/components/InvoiceModal";
import InvoicePDFViewer from "../../../../Shared/components/InvoicePDFViewer";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import businessActions from "../../../../Admin/Home/redux/actions";
import {
    capitalizeFirstLetter, currencyFormat, storageSetItem, downloadTitle, getUploadedFile, getBusinessId, checkBillProductView,
    checkCRUDViewPermission, checkComponentPermission, scrollToError, getColumnWidth, gstCalculation, includeGstSettings, idNamingConversion
} from "../../../../../helpers/utilities";
import moment from 'moment';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import CloseIcon from "../../../../Shared/components/Icons/CloseIcon";
import { AESDecrypt, AESEncrypt } from "../../../../../helpers/Crypto";
import { templateType, billLineHead } from '../../../../../config/constant';
import { useEventListener } from "../../../../../helpers/useEventListener";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import CustomerProducts from "./CustomerProducts";
import { v4 as uuidv4 } from 'uuid';
import { getRequest } from '../../../../../helpers/axiosClient';
import FreeProduct from './FreeProduct'

// Cache of details-array -> Map(id -> object) so customObject() is O(1) instead of
// re-scanning the whole list on every render for each of the ~27 dropdowns. Keyed by the
// array reference (WeakMap), so a new Redux payload naturally invalidates the entry.
const objectIdCache = new WeakMap();
const EMPTY_RESULT = Object.freeze([]);

// Static dropdown heads hoisted out so they are not re-allocated on every render (a fresh
// array literal would defeat React.memo on AutoCompleteComponent).
const CUSTOMER_HEADS = [
    { 'key': 'name', 'name': 'Customer Name' },
    { 'key': 'mobile', 'name': 'Phone Number' },
    { 'key': 'serialNo', 'name': 'Customer ID' }
];

const PRODUCT_HEADS_NAME = [
    { 'key': 'productName', 'name': 'Product Name' },
    { 'key': 'code', 'name': 'Product Code' },
    { 'key': 'productId', 'name': 'Product ID' }
];

const PRODUCT_HEADS_DESC = [
    { 'key': 'description', 'name': 'Product Name' },
    { 'key': 'code', 'name': 'Product Code' },
    { 'key': 'productId', 'name': 'Product ID' }
];

// Shared single-column heads.
const HEADS_NAME = [{ 'key': 'name', 'name': 'Name' }];
const HEADS_CODE = [{ 'key': 'code', 'name': 'Code' }];
const HEADS_LABEL = [{ 'key': 'label', 'name': 'Name' }];

// Multi-column heads, one per dropdown.
const MOP_HEADS = [{ 'key': 'method', 'name': 'Method' }, { 'key': 'description', 'name': 'Description' }];
const CURRENCY_HEADS = [{ 'key': 'name', 'name': 'Currency Name' }, { 'key': 'shortName', 'name': 'Currency Short Form' }];
const STATE_HEADS = [{ 'key': 'name', 'name': 'State Name' }, { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }];
const COUNTRY_HEADS = [{ 'key': 'name', 'name': 'Country Name' }];
const PINCODE_HEADS = [{ 'key': 'code', 'name': 'Pincode' }, { 'key': 'city', 'name': 'City', 'relation': 'name' }];
const CITY_HEADS = [{ 'key': 'name', 'name': 'Name' }, { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }];
const AREA_HEADS = [
    { 'key': 'name', 'name': 'Area Name' },
    { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
    { 'key': 'city', 'name': 'City', 'relation': 'name' },
    { 'key': 'state', 'name': 'State', 'relation': 'shortName' }
];
const PARTY_GST_HEADS = [{ 'key': 'code', 'name': 'Party GST Code' }, { 'key': 'description', 'name': 'Description' }];
const UNIT_HEADS = [{ 'key': 'name', 'name': 'Unit' }, { 'key': 'description', 'name': 'Description' }];
const LOCATION_HEADS = [{ 'key': 'name', 'name': 'Location Name' }];
const PRODUCT_GST_HEADS = [{ 'key': 'code', 'name': 'Product GST Code' }, { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }];
const HSN_HEADS = [{ 'key': 'hsnCode', 'name': 'HSN Code' }, { 'key': 'description', 'name': 'Description' }];

// Static option list for the Round Off dropdown.
const ROUNDOFF_OPTIONS = [{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }];

// Static (JSX-free) name labels, hoisted so they are not re-allocated every render.
const NAME_ROUND_OFF = ["Round Off"];
const NAME_CASH_DISCOUNT = ["Cash Discount"];
const NAME_TAX_CODE = ["Tax Code"];
const NAME_TCS = ["TCS"];
const NAME_MOP = ["Method of Payment (MOP)"];
const NAME_COUNTRY = ["Country"];
const NAME_CITY = ["Dist/City/Town"];
const NAME_AREA = ["Area"];
const NAME_PARTY_GST = ["Party GST Code "];
const NAME_LOCATION = ["Location"];
const NAME_PRODUCT_GST = ["Product GST Code"];
const NAME_HSN = ["HSN Code"];

// Returns a function whose identity never changes but which always invokes the latest
// closure. Passing this to a memoized child avoids forcing a re-render, while never
// calling a stale version of the handler.
const useStableCallback = (fn) => {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    return useRef((...args) => fnRef.current(...args)).current;
};

const SelfBillsCreate = (props) => {
    const [open, setOpen] = useState(false);
    const { businessDetails, parameterDetails, getTeamData } = useSelector(state => state.homeReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { areaDetails, pincodeDetails, stateDetails, countryDetails, cityDetails, pincodeLoader } = useSelector(state => state.addressReducer);
    const { partyGstdetails, productGstdetails, taxCodedetails, otherTaxesdetails, cashDiscountDetails, currencyDetails, mopDetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { myProductdetails, productPrices } = useSelector(state => state.productProductReducer);
    const { locationDetails } = useSelector(state => state.productSetupReducer);
    const { createDetails, createError, createLoader, createData, pdfLoader, pdfDetails, pdfError } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [visible, setVisible] = useState(false);
    const [productsVisible, setProductsVisible] = useState(false);
    const [viewVisible, setViewVisible] = useState(false);
    const [customerId, setCustomerId] = useState('');
    const [inAppStatus, setInAppStatus] = useState("");
    const [inAppTransition, setInAppTransition] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [status, setStatus] = useState('CREATED');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [reference, setReference] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [comments, setComments] = useState('');
    const [dispatchDetails, setDispatchDetails] = useState('');
    const [errorRef, setErrorRef] = useState(false);
    const [errorInvoiceNumber, setErrorInvoiceNumber] = useState(false);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [transactionDate, setTransactionDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(new Date());
    const [name, setName] = useState('');
    const [customerDetail, setCustomerDetail] = useState('');
    const [customerSerialNo, setCustomerSerialNo] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [cashDiscountId, setCashDiscountId] = useState('');
    const [cashDiscountAmount, setCashDiscountAmount] = useState('');
    const [excisesAmount, setExcisesAmount] = useState('');
    const [assessableValue, setAssessableValue] = useState('');
    const [taxCodeId, setTaxCodeId] = useState('');
    const [tax, setTax] = useState('');
    const [tcsNameId, setTcsNameId] = useState('');
    const [tcs, setTcs] = useState('');
    const [address, setAddress] = useState('');
    const [areaId, setAreaId] = useState('');
    const [salesRepId, setSalesRepId] = useState('');
    const [lineNumber, setLineNumber] = useState(1);
    const [pincodeId, setPincodeId] = useState('');
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [priceIncludesTax, setPriceIncludesTax] = useState(false);
    const [countryId, setCountryId] = useState('');
    const [gstCodeId, setGstCodeId] = useState('');
    const [includeGst, setIncludeGst] = useState(false);
    const [billFormat, setBillFormat] = useState('');
    const [total, setTotal] = useState('0.00');
    const [totalInvoice, setTotalInvoice] = useState('0.00');
    const [gstAmount, setGstAmount] = useState('0.00');
    const [roundOffAmount, setRoundOffAmount] = useState(0);
    const [roundOffMethod, setRoundOffMethod] = useState('');
    const [totalDiscount, setTotalDiscount] = useState('0.00');
    const [netAmount, setNetAmount] = useState('0.00');
    const [lines, setLines] = useState([]);
    const [primaryTitle, setPrimaryTitle] = useState('Add');
    const [unitPriceList, setUnitPriceList] = useState(false);
    const [unitPriceFocusList, setUnitPriceFocusList] = useState(false);
    const [lineId, setLineId] = useState('');
    const [lineProductId, setLineProductId] = useState('');
    const [lineLocationId, setLineLocationId] = useState('');
    const [lineDescription, setLineDescription] = useState('');
    const [lineQuantity, setLineQuantity] = useState('');
    const [lineUnitId, setLineUnitId] = useState('');
    const [lineStock, setLineStock] = useState({});
    const [productLineUnitId, setProductLineUnitId] = useState('');
    const [batch, setBatch] = useState([]);
    const [freeBatch, setFreeBatch] = useState([]);
    const [, setBatchDetails] = useState([]);
    const [linePrice, setLinePrice] = useState('');
    const [lineAmount, setLineAmount] = useState('');
    const [lineCostPrice, setLineCostPrice] = useState('');
    const [lineMrp, setLineMrp] = useState('');
    const [lineSalesValue, setLineSalesValue] = useState('');
    const [lineUniversalProductId, setLineUniversalProductId] = useState('');
    const [lineUseMrp, setLineUseMrp] = useState(false);
    const [lineDiscountAmount, setLineDiscountAmount] = useState('');
    const [lineDiscountType, setLineDiscountType] = useState(parameterDetails?.discountRate ? 'perUnit' : 'fixed');
    const [lineDiscountRate, setLineDiscountRate] = useState('');
    const [lineDiscountPercentage, setLineDiscountPercentage] = useState('');
    const [lineDiscountPercAmount, setLineDiscountPercAmount] = useState(0);
    const [lineDiscountCalcAmount, setLineDiscountCalcAmount] = useState(0);
    const [units, setUnits] = useState([]);
    const [lineIncludeGst, setLineIncludeGst] = useState(false);
    const [lineProductGstId, setLineProductGstId] = useState('');
    const [availableQuantity, setAvailableQuantity] = useState('');
    const [freeAvailableQuantity, setFreeAvailableQuantity] = useState('');
    const [lineHsnId, setLineHsnId] = useState('');
    const [lineGstAmount, setLineGstAmount] = useState('');
    const [lineCgst, setLineCgst] = useState('');
    const [lineSgst, setLineSgst] = useState('');
    const [lineIgst, setLineIgst] = useState('');
    const [includeDisabled, setIncludeDisabled] = useState(true);
    const [lineEdit, setLineEdit] = useState(false);
    const [value, setValue] = useState('lineView');
    const [showNameDesc, setShowNameDesc] = useState(checkBillProductView());
    const [lineCgstAmount, setLineCgstAmount] = useState('');
    const [lineSgstAmount, setLineSgstAmount] = useState('');
    const [lineIgstAmount, setLineIgstAmount] = useState('');
    const [stockLoading, setStockLoading] = useState(false);
    const [lineCess, setLineCess] = useState(false);
    const [lineCessType] = useState('PERCENTAGE');
    const [lineCessValue] = useState(0);
    const [, setLineCessAmount] = useState(0);
    const [lineExcisesApplicable, setLineExcisesApplicable] = useState(false);
    const [lineExcisesType, setLineExcisesType] = useState('perUnit');
    const [lineSplExcisesType, setLineSplExcisesType] = useState('perUnit');
    const [lineExcisesRate, setLineExcisesRate] = useState('');
    const [lineSplExcisesRate, setLineSplExcisesRate] = useState('');
    const [lineExcisesAmount, setLineExcisesAmount] = useState('');
    const [lineSplExcisesAmount, setLineSplExcisesAmount] = useState('');
    const [lineAddExcisesAmount, setLineAddExcisesAmount] = useState('');
    const [lineExcisesTotal, setLineExcisesTotal] = useState('');
    const [lineTotalCostPrice, setLineTotalCostPrice] = useState('');

    const [errorLineDescription, setErrorLineDescription] = useState('');
    const [errorRoundOffAmount, setErrorRoundOffAmount] = useState('');
    const [errorLineUnitId, setErrorLineUnitId] = useState('');
    const [errorDiscountAgreements, setErrorDiscountAgreements] = useState('');
    const [errorLinePrice, setErrorLinePrice] = useState('');
    const [errorLineQuantity, setErrorLineQuantity] = useState('');
    const [errorBatchQuantity, setErrorBatchQuantity] = useState(false);
    const [errorFreeBatchQuantity, setErrorFreeBatchQuantity] = useState(false);
    const [errorLineExcisesAmount, setErrorLineExcisesAmount] = useState(false);
    const [errorLineSplExcisesAmount, setErrorLineSplExcisesAmount] = useState(false);
    const [errorLineProductGst, setErrorLineProductGst] = useState('');
    const [errorLineHsn, setErrorLineHsn] = useState('');
    const [errorState, setErrorState] = useState('');
    const [errorDueDate, setErrorDueDate] = useState(false);
    const [errorInvoiceDate, setErrorInvoiceDate] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [preview, setPreview] = useState(false);
    const childRef = useRef('');
    const priceRef = useRef(null);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const { history } = props;
    let { selfBillCustomerId } = useParams();
    let { type } = useParams();
    const decryptedId = AESDecrypt(selfBillCustomerId);
    const [mopId, setMopId] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [errorCustomerId, setErrorCustomerId] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    const [errorPincode, setErrorPincode] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorGstCode, setErrorGstCode] = useState(false);
    const [creditNote, setCreditNote] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [dateChange, setDateChange] = useState('');
    const [invoiceConfirmed] = useState(false);
    const prevPdfDetails = usePrevious(pdfDetails);
    const prevPdfError = usePrevious(pdfError);
    const [prefix, setPrefix] = useState('');
    const [viewBatch, setViewBatch] = useState(false);
    const [autoMark, setAutoMark] = useState(false);
    const [pdfPreview, setPdfPreview] = useState(false);
    const [selectedBatchId, setSelectedBatchId] = useState([]);
    const [selectedFreeBatchId, setSelectedFreeBatchId] = useState([]);
    const [freeProduct, setFreeProduct] = useState({});
    const [showFreeProduct, setShowFreeProduct] = useState(false);


    const handleOpen = () => {
        setLineEdit(true);
        if (customerId === '') {
            toast.dismiss();
            toast.error('Please Choose Customer');
        } else if (includeGst && gstCodeId === '') {
            toast.warning('Please Select Party GST code');
        } else {
            setVisible(true);
            emptyLineState();
            emptyLineStateInput();
            setLineNumber(parseInt(lines.length + 1));
            setPrimaryTitle('Add');
            dispatch({ type: productActions.CLEAR_PRICE_START });
            hsnApi();
            setUnits(unitMesurementdetails);
            productApi();
            locationApi();
            setFreeBatch([]);
            setSelectedFreeBatchId([]);
            setFreeProduct({});
            setErrorFreeBatchQuantity(false);
            setShowFreeProduct(false);
        }
    };

    const handleClose = () => {
        setVisible(false);
        emptyLineState();
        emptyLineStateInput();
        setShowFreeProduct(false); setFreeProduct({});
    }

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleViewClose = () => {
        setViewVisible(false);
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkCRUDViewPermission('Sales Bill', 'create', history, 'Sales')) {
                loadTasks();
                if (type === 'credit-note') {
                    setCreditNote(true);
                }
            }
        }
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: actions.CLEAR_MANAGEMENT_DETAILS_START });
        };
    }, [roleManagement]);


    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 76) {
            e.preventDefault();
            handleOpen();
        } else if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (visible) {
                handleLineSubmit(e);
            } else if (confirm) {
                handleCommonSubmit('CONFIRMED');
            } else {
                handleSubmit(e);
            }
        } else if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            if (lines && lines?.length === 0) {
                toast.dismiss();
                toast.error('If you want confirm, Please add lines and then confirm it...');
            } else {
                handleConfirmSubmit();
                //setConfirm(true);
            }
        }
    };

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (businessDetails) {
            if (businessDetails?.taxType?.taxCode === 'COMP') {
                setBillFormat('billSupply');
            } else {
                let a = customObject(templateType, businessDetails?.businessDocumentTemplates[0]?.self_bill_template);
                setBillFormat(a?.id || 'format1');
            }
        }
    }, [businessDetails]);

    useEffect(() => {
        let filter = '';
        if (type === 'self-bill') {
            filter = { where: { ["and"]: [{ businessId: getBusinessId() }, { prefix: 'CI' }, { prefixType: 'MANUAL' }] }, };
        } else {
            filter = { where: { ["and"]: [{ businessId: getBusinessId() }, { prefix: 'CN' }, { prefixType: 'MANUAL' }] }, };
        }
        let response = getRequest(`${process.env.REACT_APP_API_URL}/activity-counters?filter=${encodeURIComponent(JSON.stringify(filter))}`);

        response.then(payload => {
            // Handle the fetched data here
            let data = payload.data;
            if (data && data?.length) {
                setPrefix(data[0]);
            }
        }).catch(error => {
            // Handle any errors
        })
    }, []);


    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id asc',
                limit: 500,
                skip: 0
            },
        });
    }


    const hsnApiArray = (ids = []) => {
        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: { id: { inq: ids } },
                order: 'id asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({ type: businessActions.BUSINESS_DETAILS_START });
        if (selfBillCustomerId !== undefined && decryptedId !== 0) {
            customerApi('', decryptedId);
        } else {
            customerApi();
        }
        //hsnApi('');
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: businessActions.TEAM_DETAILS_START, url: 'team', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.OTHERTAXES_DETAILS_START, url: 'othertaxes', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    });

    // Compact signature over only the fields calculateGrandTotal reads, instead of
    // JSON.stringify-ing every full line object on every render.
    const linesTotalsSignature = Array.isArray(lines)
        ? lines.map(v => `${v.amount}|${v.discountAmount}|${v.quantity}|${v.pricePerUnit}|${v.discountPercent}|${v.gstAmount}|${v.excisesTotal}`).join(';')
        : '';

    useEffect(() => {
        calculateGrandTotal(lines);
    }, [linesTotalsSignature, businessDetails, cashDiscountDetails, taxCodedetails, taxCodeId, otherTaxesdetails, tcsNameId, cashDiscountId]);

    const emptyState = () => {
        setErrorCustomerId(false);
        setErrorCurrency(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorGstCode(false);
        setErrorState(false);
        setErrorDueDate(false);
        setErrorInvoiceDate(false);
        setErrorPincode(false);
        setCommonError(false);
        setErrorRef(false); setErrorInvoiceNumber(false);
        setErrorRoundOffAmount(false);
    }

    const calculateGrandTotal = (lines) => {
        if (lines && lines.length > 0) {
            let total = lines && lines.reduce((a, v) => a = a + v.amount, 0);
            let discount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.discountAmount || 0), 0);
            let discountPercent = lines && lines.reduce((a, v) => {
                if (v.amount < 0) {
                    a = parseFloat(a) - parseFloat(((v.quantity * v.pricePerUnit) * parseFloat(v?.discountPercent || 0)) / 100)
                } else {
                    a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * parseFloat(v?.discountPercent || 0)) / 100)
                }
                return a;
            }, 0);
            let gst = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0);

            setTotalDiscount(discount + discountPercent);
            setGstAmount(parseFloat(parseFloat(gst).toFixed(2)));
            let excisesAmount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.excisesTotal || 0), 0);
            let disAmount = 0;
            if (cashDiscountDetails && cashDiscountDetails?.length > 0) {
                let data = cashDiscountDetails.find((el) => { return el.id === cashDiscountId });
                if (data) {
                    disAmount = (total * (data?.percentage || 0)) / 100;
                }
            }
            setCashDiscountAmount(disAmount);
            setExcisesAmount(excisesAmount);
            // if (excisesAmount) {
            let assessableAmount = parseFloat(total || 0) - parseFloat(disAmount || 0) + parseFloat(excisesAmount || 0);

            if (priceIncludesTax) {
                assessableAmount = parseFloat(assessableAmount || 0) - parseFloat(gst || 0);
            }

            setAssessableValue(parseFloat(parseFloat(assessableAmount).toFixed(2)));
            let taxValue = 0;
            if (taxCodedetails && taxCodedetails?.length > 0) {
                let data = taxCodedetails.find((el) => { return el.id === taxCodeId });
                if (data) {
                    taxValue = ((assessableAmount || 0) * (data?.percentage || 0)) / 100;
                    setTax(taxValue);
                }
            }

            let tcsValue = 0;
            let tcsAmount = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0);
            if (customerDetail.tcsBoolean) {
                let data = otherTaxesdetails.find((el) => { return el.id === tcsNameId });
                tcsValue = (tcsAmount * (data?.percentage || 0)) / 100;
                setTcs(tcsValue);
            }

            total = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0) + parseFloat(tcsValue || 0);

            //  }
            // if (priceIncludesTax) {
            //     setTotal(parseFloat(parseFloat(total).toFixed(2)));
            //     setTotalInvoice(parseFloat(parseFloat(total).toFixed(2)));
            //     if (excisesAmount) {
            //         setNetAmount(parseFloat(parseFloat(totalNetAmount - gst).toFixed(2)));
            //     } else {
            //         setNetAmount(parseFloat(parseFloat(total - gst).toFixed(2)));
            //     }
            // } else {
            //     setTotal(parseFloat(parseFloat(total + gst).toFixed(2)));
            //     setTotalInvoice(parseFloat(parseFloat(total + gst).toFixed(2)));
            //     if (excisesAmount) {
            //         setNetAmount(parseFloat(parseFloat(totalNetAmount).toFixed(2)));
            //     } else {
            //         setNetAmount(parseFloat(parseFloat(total).toFixed(2)));
            //     }
            // }

            setTotal(parseFloat(parseFloat(total + gst + (parseFloat(roundOffAmount || 0))).toFixed(2)));
            setTotalInvoice(parseFloat(parseFloat(total + gst).toFixed(2)));
            setNetAmount(parseFloat(parseFloat(assessableAmount).toFixed(2)));


            // if (total < 0) {
            //     setTotalDiscount(discount - discountPercent);
            // } else {
            //     setTotalDiscount(discount + discountPercent);
            // }

        } else {
            setTotal(0);
            setTotalInvoice(0);
            setTotalDiscount(parseFloat(0.00));
            setGstAmount(parseFloat(0.00));
            setNetAmount(parseFloat(0.00));
            setExcisesAmount(parseFloat(0.00));
            setAssessableValue(parseFloat(0.00));
            setTax(parseFloat(0.00));
        }
    }

    const emptyLineState = () => {
        setErrorLineDescription(false);
        setErrorLineUnitId(false);
        setErrorDiscountAgreements(false);
        setErrorLinePrice(false);
        setErrorLineQuantity(false);
        setErrorBatchQuantity(false);
        setErrorFreeBatchQuantity(false);
        // setErrorLineAmount(false);
        setErrorLineProductGst(false);
        setErrorLineHsn(false);
        setErrorLineExcisesAmount(false);
        setErrorLineSplExcisesAmount(false);
    }


    useEffect(() => {
        if (selfBillCustomerId !== undefined && decryptedId !== 0 && customerDetails && customerDetails?.length > 0) {
            let a = customerDetails?.filter((el) => { return el?.id === parseInt(decryptedId) });
            if (a && a?.length > 0) {
                if (a[0]?.isHold) {
                    toast.error('Please release the Customer from ON-HOLD to allow for transaction to be created.');
                    history.push("/sales/sales-management/all-customers");
                } else {
                    changeCustomer(a[0]);
                }
            }
        }
    }, [customerDetails]);


    useEffect(() => {
        if (selfBillCustomerId !== undefined && decryptedId !== 0 && customerDetails && customerDetails?.length > 0 && businessDetails?.businessId) {
            let a = customerDetails?.filter((el) => { return el?.id === parseInt(decryptedId) });
            if (a && a?.length > 0) {
                gstSettings(businessDetails, a[0]);
            }
        }
    }, [businessDetails, customerDetails]);


    useEffect(() => {
        if (preview && hsnDetails && hsnDetails.length > 0) {
            setDataPreview();
        }
    }, [preview, hsnDetails]);

    useEffect(() => {
        if (myProductdetails && myProductdetails?.length && lineProductId) {
            let a = myProductdetails && myProductdetails.find(function (el) { return el.id === lineProductId });
            handleUnits(a);
        }
    }, [myProductdetails, lineProductId]);


    const emptyLineStateInput = () => {
        setLineId('');
        setLineProductId('');
        setLineLocationId('');
        setLineDescription('');
        setLineQuantity('');
        setLineUnitId('');
        setLineStock({});
        setProductLineUnitId('');
        setLinePrice('');
        setLineAmount('');
        setLineDiscountAmount('');
        setLineDiscountType(parameterDetails?.discountRate ? 'perUnit' : 'fixed');
        setLineDiscountRate('');
        setLineDiscountPercAmount('');
        setLineDiscountCalcAmount('');
        setLineDiscountPercentage('');
        setLineProductGstId('');
        setAvailableQuantity('');
        setFreeAvailableQuantity('');
        setLineHsnId('');
        setLineGstAmount('');
        setLineCgst('');
        setLineSgst('');
        setLineIgst('');
        setLineCgstAmount('');
        setLineSgstAmount('');
        setLineIgstAmount('');
        setLineIncludeGst(includeGst);
        setLineMrp(''); setLineCostPrice(''); setLineSalesValue('');
        setLineUniversalProductId('');
        setLineUseMrp(false);
        setSelectedBatchId([]);
        setBatch([]);
        setBatchDetails([]);
        setViewBatch(false);
        setAutoMark(false);
        setFreeAvailableQuantity('');
        setLineExcisesApplicable(false);
        setLineExcisesType('perUnit');
        setLineSplExcisesType('perUnit');
        setLineExcisesRate('');
        setLineSplExcisesRate('');
        setLineExcisesAmount('');
        setLineSplExcisesAmount('');
        setLineAddExcisesAmount('');
        setLineExcisesTotal('');
        setLineTotalCostPrice('');
    }

    const handleConfirmSubmit = () => {
        childRef?.current?.handleAdjustHeight();
        let emailCheck = true;
        let incudeGstCode = true;
        let emptyCustomer = emptyValidation('Customer Name', customerId, 'dropDown');
        let emptyMobile = emptyValidation('Phone Number', mobile);
        let emptyEmail = customEmailValidation('Email', email);
        if (email !== null && email !== '' && !emptyEmail.isValid) {
            emailCheck = false;
        }
        let emptyGstCode = emptyValidation('Party GST Code', gstCodeId, 'dropDown');
        let emptyStateCheck = emptyValidation('State', stateId, 'dropDown');
        if ((includeGst && !emptyGstCode.isValid) || (includeGst && !emptyStateCheck.isValid)) {
            incudeGstCode = false
        }

        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');

        let stateCheck = true;
        if (businessDetails?.taxType?.taxCode === 'COMP' && businessDetails?.stateId !== stateId) {
            stateCheck = false;
        }
        let invoiceDateCheck = moment(moment(invoiceDate).format('YYYY-MM-DD')).isSameOrAfter(moment(transactionDate).format('YYYY-MM-DD'));
        let dueDateCheck = moment(moment(dueDate).format('YYYY-MM-DD')).isSameOrAfter(moment(invoiceDate).format('YYYY-MM-DD'));
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyRef = stringLengthOptionalValidation('Reference', reference, 30);
        let roundOff = true;
        if (roundOffMethod && roundOffAmount === '') {
            roundOff = false;
        }
        let ivNumber = true;
        let emptyinvoiceNumber = emptyValidation('Invoice Number', invoiceNumber);
        if (prefix?.id && !emptyinvoiceNumber?.isValid) {
            ivNumber = false;
        }
        emptyState();
        if (emptyCustomer.isValid && ivNumber && invoiceDateCheck && dueDateCheck && stateCheck && emptyCurrency.isValid && emptyStateCheck.isValid &&
            emptyMobile.isValid && emailCheck && incudeGstCode && emptyPincode.isValid && emptyRef.isValid && roundOff) {
            setConfirm(true);
        } else {
            setConfirm(false);
            if (emptyCustomer.errors) {
                setErrorCustomerId(emptyCustomer.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (!dueDateCheck) {
                setErrorDueDate('Due Date should greater or equal to invoice date');
            }
            if (!invoiceDateCheck) {
                setErrorInvoiceDate('Invoice Date should greater or equal to transaction date');
            }

            if (!emailCheck) {
                setErrorEmail(emptyEmail.errors);
            }
            if (includeGst && emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }
            if (emptyStateCheck.errors) {
                setErrorState(emptyStateCheck.errors);
            }

            if (emptyRef.errors) {
                setErrorRef(emptyRef.errors);
            }
            if (!roundOff) {
                setErrorRoundOffAmount('Please enter a valid value in Round Off');
            }
            if (!stateCheck) {
                toast.dismiss();
                toast.error('Please note you are in GST-Composite scheme and Sales Bill cannot be generated due to Customer billing address in different state.');
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (!invoiceNumber) {
                setErrorInvoiceNumber(emptyinvoiceNumber.errors);
            }
            let v = 'headerView';
            if (emptyCustomer?.errors || emptyMobile?.errors || !invoiceNumber || emptyRef?.errors || !roundOff) {
                v = 'lineView';
            }
            handleChange(v);
            scrollToError();
        }
    }

    const handleAllGstCalc = (element) => {
        let a = element;
        if (element.includeGst && element.productGstId) {
            let p = productGstdetails?.filter((el) => { return el.id === element.productGstId });
            let percentage = p[0].percentage;
            let details = {
                percentage: percentage,
                stateId: stateId,
                lineAmount: element.amount, priceIncludesTax: priceIncludesTax
            };
            let gstCalc = gstCalculation(businessDetails, details, customerDetail);
            a = {
                ...element,
                igstPercentage: parseFloat(gstCalc?.igst || 0),
                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                igst: parseFloat(gstCalc?.igstAmount || 0),
            };
        }
        return a;
    }

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let emailCheck = true;
        let incudeGstCode = true;
        let emptyCustomer = emptyValidation('Customer Name', customerId, 'dropDown');
        let emptyMobile = emptyValidation('Phone Number', mobile);
        let emptyEmail = customEmailValidation('Email', email);
        if (email !== null && email !== '' && !emptyEmail.isValid) {
            emailCheck = false;
        }
        let emptyGstCode = emptyValidation('Party GST Code', gstCodeId, 'dropDown');
        let emptyStateCheck = emptyValidation('State', stateId, 'dropDown');
        if ((includeGst && !emptyGstCode.isValid) || (includeGst && !emptyStateCheck.isValid)) {
            incudeGstCode = false
        }

        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');

        let stateCheck = true;
        if (businessDetails?.taxType?.taxCode === 'COMP' && businessDetails?.stateId !== stateId) {
            stateCheck = false;
        }

        let invoiceDateCheck = moment(moment(invoiceDate).format('YYYY-MM-DD')).isSameOrAfter(moment(transactionDate).format('YYYY-MM-DD'));
        let dueDateCheck = moment(moment(dueDate).format('YYYY-MM-DD')).isSameOrAfter(moment(invoiceDate).format('YYYY-MM-DD'));
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyRef = stringLengthOptionalValidation('Reference', reference, 30);
        let roundOff = true;
        if (roundOffMethod && roundOffAmount === '') {
            roundOff = false;
        }

        emptyState();
        if (emptyCustomer.isValid && invoiceDateCheck && dueDateCheck && stateCheck && emptyCurrency.isValid && emptyStateCheck.isValid &&
            emptyMobile.isValid && emailCheck && incudeGstCode && emptyPincode.isValid && emptyRef.isValid && roundOff) {
            setStatus(status);
            let aL = [];
            lines && lines?.length > 0 && lines?.map((element, i) => {
                if (element?.pricePerUnit) {
                    element.pricePerUnit = parseFloat(element?.pricePerUnit);
                }
                element.productGstId = element?.productGstId || undefined;
                element.discountAmount = element?.discountAmount ? parseFloat(element?.discountAmount) : 0;
                element.discountPercent = element?.discountPercent ? parseFloat(element?.discountPercent) : 0;
                // if (element?.batchDetails?.length > 0) {
                //     element.batchDetails?.map((batch) => {
                //         element.batchDetails.splice(i, 1, batch);
                //     });
                // }

                return aL.push({ ...handleAllGstCalc(element) })
            });
            let details = {
                name: name,
                invoiceDate: invoiceDate,
                transactionDate: moment(transactionDate).format("YYYY-MM-DDT00:00:00.000+00:00"),
                dueDate: dueDate,
                phone: mobile,
                currencyId: currencyId,
                customerId: customerId,
                selfBillItems: aL,
                billStatus: status,
                invoiceAmount: total,
                countryId: countryId,
                includeGst: includeGst,
                gstAmount: gstAmount,
                comments: comments || '',
                dispatchDetails: dispatchDetails || '', roundOffMethod: roundOffMethod || null, roundOffAmount: parseFloat(roundOffAmount || 0),
                billFormat: billFormat, reference: reference ? reference : '', manualInvoiceNo: invoiceNumber || '',
                priceIncludesTax: priceIncludesTax || false,
                cashDiscountAmount: cashDiscountAmount || 0,
                cashDiscountId: cashDiscountId || 0
            };

            let a = customerDetails && customerDetails?.filter((el) => { return el?.id === parseInt(customerId) });
            if (a && a?.length !== 0) {
                if (a[0]?.gstin && a[0]?.gstin !== '') {
                    details["gstin"] = a[0]?.gstin;
                }
            }
            if (inAppTransition) {
                details["inAppTransition"] = inAppTransition;
            } else {
                details["inAppTransition"] = false;
            }
            if (email) {
                details["email"] = email;
            }
            if (fromDate) {
                details["fromDate"] = fromDate;
            }
            if (toDate) {
                details["toDate"] = toDate;
            }
            if (address) {
                details["address1"] = address;
            }
            if (salesRepId) {
                details["salesRepId"] = salesRepId;
            }
            if (gstCodeId) {
                details["partyGstId"] = gstCodeId;
            }
            if (mopId) {
                details["mopId"] = mopId;
            }
            if (areaId) {
                details["areaId"] = areaId;
            }
            if (pincodeId) {
                details["pincodeId"] = pincodeId;
            }
            if (stateId) {
                details["stateId"] = stateId;
            }
            if (cityId) {
                details["cityId"] = cityId;
            }

            if (cityId) {
                details["cityId"] = cityId;
            }

            if (assessableValue) {
                details["assessableValue"] = assessableValue;
            }

            if (excisesAmount) {
                details["excisesAmount"] = excisesAmount;
            }

            if (taxCodeId) {
                details["taxCodeId"] = taxCodeId;
            }

            if (tcsNameId) {
                details["tcsNameId"] = tcsNameId;
            }

            if (tax) {
                details["tax"] = tax;
            }

            if (tcs) {
                details["tcs"] = tcs;
            }

            if (callDispatch) {
                // if (details.billStatus === 'CONFIRMED' && !invoiceConfirmed) {
                //     //handlePreviewApi();
                //     setInvoiceConfirmed(true);
                // } else {

                // }
                aL && aL.length > 0 && aL.map((element, i) => {
                    delete element.productGst; delete element.product; delete element.productCategory;
                    delete element.hsn;
                    delete element.unit; delete element.stockUnit; delete element.costPrice;
                    if (element?.batchDetails?.length > 0) {
                        element.batchDetails = element.batchDetails.map((el) => {
                            const { batch, ...rest } = el; // remove batch
                            return rest; // return object without batch
                        });
                    }

                    aL.splice(i, 1, element);
                });
                details.selfBillItems = aL;
                dispatch({
                    type: crudActions.CREATE_DETAILS_START,
                    url: 'selfBill',
                    title: 'Sales Bill',
                    details: details
                })
            } else {
                return details;
            }
        }
        else {
            setConfirm(false)
            if (emptyCustomer.errors) {
                setErrorCustomerId(emptyCustomer.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (!dueDateCheck) {
                setErrorDueDate('Due Date should greater or equal to invoice date');
            }
            if (!invoiceDateCheck) {
                setErrorInvoiceDate('Invoice Date should greater or equal to transaction date');
            }
            if (!emailCheck) {
                setErrorEmail(emptyEmail.errors);
            }
            if (includeGst && emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }
            if (emptyStateCheck.errors) {
                setErrorState(emptyStateCheck.errors);
            }

            if (!stateCheck) {
                toast.dismiss();
                toast.error('Please note you are in GST-Composite scheme and Sales Bill cannot be generated due to Customer billing address in different state.');
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptyRef.errors) {
                setErrorRef(emptyRef.errors);
            }
            if (!roundOff) {
                setErrorRoundOffAmount('Please enter a valid value in Round Off');
            }
            let v = 'headerView';
            if (emptyCustomer?.errors || emptyMobile?.errors || emptyRef?.errors || !roundOff) {
                v = 'lineView';
            }

            handleChange(v);
            scrollToError();
            if (!callDispatch) {
                return false;
            }
        }
    }

    const handleChange = (newValue) => {
        setValue(newValue);
        childRef?.current?.handleAdjustHeight();
        storageSetItem('salesView', newValue);
    };

    const handleSubmit = (e, status = 'CREATED') => {
        e.preventDefault();
        handleCommonSubmit(status);
    }

    const handlePreview = () => {
        let data = handleCommonSubmit('CREATED', false);
        if (data) {
            let hsnIds = [];
            if (data?.selfBillItems && data?.selfBillItems?.length > 0) {
                data?.selfBillItems?.map(function (element, i) {
                    if (element?.hsnId) {
                        hsnIds.push(element?.hsnId);
                    }
                });
            }

            if (hsnIds.length > 0) {
                hsnApiArray(hsnIds);
            } else {
                setDataPreview();
            }

            setPreview(true);
            setOpen(true);
        }
    }

    const handlePreviewApi = () => {
        let data = setDataPreview(true);
        if (data) {
            dispatch({
                type: crudActions.PDFGENERATE_START,
                url: '/v1/pdfgenerator/generatepdfinvoice',
                title: 'Sales Bill',
                details: {
                    fileUri: `client/${businessDetails?.serialNo}/salesbill/${uuidv4()}.pdf`,
                    templateId: data?.billFormat + '-Sales',
                    data: data
                }
            });
        }
    }

    useEffect(() => {
        if (prevPdfDetails !== undefined && pdfDetails && prevPdfDetails !== pdfDetails) {
            // setFileUri(getUploadedFile(JSON.parse(pdfDetails.resp).fileUri));
            if (invoiceConfirmed) {
                setTimeout(() => {
                    handleCommonSubmit('CONFIRMED');
                }, 100);
            } else {
                setPreview(true);
                setPdfPreview(getUploadedFile(JSON.parse(pdfDetails.resp).fileUri));
            }
        } else if (prevPdfError !== undefined && pdfError && prevPdfError !== pdfError) {
            toast.dismiss();
            toast.error(pdfError);
        }
    }, [pdfDetails, pdfError]);

    const setDataPreview = (a = false) => {
        let data = handleCommonSubmit('CREATED', false);

        if (data) {
            data['business'] = businessDetails;
            if (data?.areaId) {
                data['area'] = customObject(areaDetails, data?.areaId);
            }
            if (data?.pincodeId) {
                data['pincode'] = customObject(pincodeDetails, data?.pincodeId);
            }
            if (data?.stateId) {
                data['state'] = customObject(stateDetails, data?.stateId);
            }
            if (data?.cityId) {
                data['city'] = customObject(cityDetails, data?.cityId);
            }
            if (data?.countryId) {
                data['country'] = customObject(countryDetails, data?.countryId);
            }
            if (data?.currencyId) {
                data['currency'] = customObject(currencyDetails, data?.currencyId);
            }
            if (data?.mopId) {
                data['mop'] = customObject(mopDetails, data?.mopId);
            }
            if (data?.customerId) {
                data['customer'] = customObject(customerDetails, data?.customerId);
            }
            if (data?.taxCodeId) {
                data['taxCode'] = customObject(taxCodedetails, data?.taxCodeId);
            }
            if (data?.cashDiscountId) {
                data['cashDiscount'] = customObject(cashDiscountDetails, data?.cashDiscountId);
            }
            if (data?.tcsNameId) {
                data['tcsName'] = customObject(otherTaxesdetails, data?.tcsNameId);
            }
            if (data?.selfBillItems && data?.selfBillItems?.length > 0) {
                data?.selfBillItems?.map(function (element, i) {
                    // element['lineNumber'] = i + 1;
                    element.lineNumber = i + 1;
                    // if (element?.hsnId) {
                    //     // element['hsn'] = customObject(hsnDetails, element?.hsnId);
                    //     element.hsn = customObject(hsnDetails, element?.hsnId);
                    // }
                    if (element?.unitId) {
                        //element['unit'] = customObject(unitMesurementdetails, element?.unitId);
                        element.unit = customObject(unitMesurementdetails, element?.unitId);
                    }
                    if (element?.productGstId) {
                        // element['productGst'] = customObject(productGstdetails, element?.productGstId);
                        element.productGst = customObject(productGstdetails, element?.productGstId);
                    }
                    let mLines = { ...element };
                    data?.selfBillItems?.splice(i, 1, mLines);
                });
            }

            if (a) {
                return data;
            } else {
                setPreviewData(data);
            }
        }
    }

    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = countryDetails && countryDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCurrencyId(a[0].currencyId);
        }
    }

    const handleIncludeGst = (value) => {
        if (!value) {
            setModalVisible(true);
        } else {
            setIncludeGst(value);
            setLineIncludeGst(value);
            lines && lines.length > 0 && lines.map(function (element, i) {
                let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === gstCodeId });
                if (party.length !== 0) {
                    if (element.productGstId) {
                        let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === element.productGstId });
                        if (p.length !== 0) {
                            let percentage = p[0].percentage;
                            let details = {
                                percentage: percentage,
                                stateId: stateId,
                                lineAmount: element.amount, priceIncludesTax: priceIncludesTax
                            };
                            let gstCalc = gstCalculation(businessDetails, details, customerDetail);
                            let mLines = {
                                ...element,
                                includeGst: true,
                                igstPercentage: parseFloat(gstCalc?.igst || 0),
                                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                                igst: parseFloat(gstCalc?.igstAmount || 0),
                                gstAmount: parseFloat(gstCalc.gAmount || 0),
                            };

                            lines.splice(i, 1, mLines);
                        }
                    }
                }
            });
        }
    }

    const handleWarningYes = () => {
        setModalVisible(false);
        setIncludeGst(false);
        setLineIncludeGst(false);
        lines && lines.length > 0 && lines.map(function (element, i) {
            let mLines = {
                ...element,
                includeGst: false,
                igstPercentage: 0,
                cgstPercentage: 0,
                sgstPercentage: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
            };
            lines.splice(i, 1, mLines);
        });
    }

    const calculateTotal = () => {
        //if (lineQuantity > 0) {
        setLineCgst('');
        setLineSgst('');
        setLineIgst('');
        setLineCgstAmount('');
        setLineSgstAmount('');
        var amount = parseFloat(lineQuantity) * parseFloat(linePrice);
        var dPAmount = 0;
        var gAmount = 0;
        var dTotal = 0;
        if (lineUnitId === productLineUnitId) {
            if (lineUseMrp && lineMrp !== '' && parseFloat(lineMrp) < parseFloat(linePrice)) {
                toast.dismiss();
                toast.warning('Unit price is greater than MRP Price');
            }
        }

        setLineSalesValue(amount || '');
        if (lineDiscountPercentage !== '') {
            dPAmount = dTotal = parseFloat((amount * lineDiscountPercentage) / 100);
        }

        let discountAmount = lineDiscountAmount;
        if (lineDiscountType === 'perUnit') {
            const qty = parseFloat(lineQuantity || 0);
            const rate = parseFloat(lineDiscountRate || 0);
            discountAmount = Math.abs(qty) * Math.abs(rate);
            setLineDiscountAmount(discountAmount);
        }


        if (discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(discountAmount);
            }
            // dTotal = parseFloat(dPAmount) + parseFloat(lineDiscountAmount);
        }

        var lineAmount = amount - dTotal;
        // if (lineAmount < 0) {
        setLineAmount(lineAmount);
        // toast.dismiss();
        //toast.error('Line amount cannot be less than zero.');
        //return false;
        // }

        if (lineProductGstId !== '' && lineIncludeGst) {
            if (gstCodeId === '') {
                setLineProductGstId('');
                toast.dismiss();
                toast.warning('Please select party GST code');
                return false;
            }
            let party = partyGstdetails && partyGstdetails.filter((el) => { return el.id === gstCodeId });
            if (party.length !== 0) {
                let p = party[0].productGsts && party[0].productGsts.filter((el) => { return el.id === lineProductGstId });
                if (p && p.length !== 0) {
                    let percentage = p[0].percentage;
                    let details = {
                        percentage: percentage,
                        stateId: stateId,
                        lineAmount: lineAmount,
                        cess: lineCess,
                        cessType: lineCessType,
                        cessValue: parseFloat(lineCessValue), priceIncludesTax: priceIncludesTax
                    };
                    let gstCalc = gstCalculation(businessDetails, details, customerDetail);
                    setLineCgst(parseFloat(gstCalc?.cgst || 0));
                    setLineSgst(parseFloat(gstCalc.sgst || 0));
                    setLineCgstAmount(parseFloat(gstCalc?.cgstAmount || 0));
                    setLineSgstAmount(parseFloat(gstCalc?.sgstAmount || 0));
                    setLineIgst(parseFloat(gstCalc?.igst || 0));
                    setLineIgstAmount(parseFloat(gstCalc?.igstAmount || 0));
                    setLineCessAmount(parseFloat(gstCalc?.cessAmount || 0));
                    gAmount = gstCalc.gAmount;
                } else {
                    toast.dismiss();
                    toast.error('This Product GST Code is not relevant for the Chosen Party GST Code, Please Check');
                    setLineProductGstId('');
                }
            }
        }
        setLineGstAmount(gAmount);
        setLineDiscountPercAmount(dPAmount);
        setLineDiscountCalcAmount(dTotal);
        setLineAmount(lineAmount);
        if (lineExcisesApplicable) {
            let excisesAmount = 0;
            let splExcisesAmount = 0;
            if (lineExcisesType === 'perUnit') {
                const qty = parseFloat(lineQuantity || 0);
                const rate = parseFloat(lineExcisesRate || 0);
                excisesAmount = Math.abs(qty) * Math.abs(rate);
                setLineExcisesAmount(excisesAmount);
            } else {
                excisesAmount = lineExcisesAmount;
            }
            if (lineSplExcisesType === 'perUnit') {
                const sqty = parseFloat(lineQuantity || 0);
                const srate = parseFloat(lineSplExcisesRate || 0);
                splExcisesAmount = Math.abs(sqty) * Math.abs(srate);
                setLineSplExcisesAmount(splExcisesAmount);
            } else {
                splExcisesAmount = lineSplExcisesAmount;
            }
            let excisesTotal = parseFloat(excisesAmount || 0) + parseFloat(splExcisesAmount || 0) + parseFloat(lineAddExcisesAmount || 0);
            setLineExcisesTotal(parseFloat(lineQuantity || 0) < 0 ? -excisesTotal : excisesTotal);
            setLineTotalCostPrice(parseFloat(lineQuantity || 0) < 0 ? -(excisesTotal - (lineAmount || 0)) : (excisesTotal + (lineAmount || 0)));
        }
        // }
    }

    useEffect(() => {
        calculateTotal();
    }, [lineQuantity, linePrice, lineExcisesRate, lineExcisesAmount, lineSplExcisesRate, lineSplExcisesAmount, lineAddExcisesAmount, lineDiscountAmount, lineCessType, lineCessValue, lineDiscountPercentage, lineProductGstId, viewVisible, visible]);

    useEffect(() => {
        if (lineUseMrp && lineMrp !== '' && parseFloat(lineMrp) < parseFloat(linePrice)) {
            toast.dismiss();
            toast.warning('Unit price is greater than MRP Price');
        }
    }, [lineUseMrp]);

    useEffect(() => {
        handleSetProductPrice(lineUnitId, lineEdit);
    }, [productPrices]);

    const handleSetProductPrice = (lineUnitId = '', lineEdit) => {
        if (productPrices && productPrices !== '') {
            let d = customObject(myProductdetails, lineProductId);
            if (parameterDetails?.aggrementSalesPrice && productPrices?.priceagreement && Object.keys(productPrices?.priceagreement).length > 0 &&
                productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                let result = productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name][0];
                if (!lineEdit) {
                    setLinePrice(result?.price || d?.latestPurchasePrice || '');
                    setLineMrp(result?.mrp || d?.mrp || '');
                    setLineSplExcisesRate(result?.specialExcisesDuty || '');
                }
                setUnitPriceList(true);
                setLineUseMrp(result?.isMrp);
            } else {
                if (!lineEdit) {
                    if (parameterDetails?.lastSalesPrice && productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                        productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                        let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name];
                        setLinePrice(result?.price || d?.latestPurchasePrice || '');
                        if (result?.mrp || d?.mrp) {
                            setLineMrp(result?.mrp || d?.mrp || '');
                            setLineUseMrp(true);
                        }
                        setUnitPriceList(false);
                    } else {
                        if (parameterDetails?.productUnitPrice) {
                            let d = customObject(myProductdetails, lineProductId);
                            if (d) {
                                setLineUseMrp(d?.useMrp);
                                setLinePrice(d?.costPrice || '');
                                setLineMrp(d?.mrp || '');
                            }
                        }

                    }
                }
            }
            if (!lineEdit) {
                if (productPrices?.discountagreement && Object.keys(productPrices?.discountagreement).length > 0 &&
                    productPrices?.discountagreement[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                    let result = productPrices?.discountagreement[customObject(unitMesurementdetails, lineUnitId)?.name][0];
                    if (parameterDetails?.discountRate) {
                        setLineDiscountRate(result?.price || '');
                    } else {
                        setLineDiscountAmount(result?.price || '');
                    }
                    if (result?.percentage) {
                        setLineDiscountPercentage(result?.percentage || '');
                    }
                } else if (productPrices?.lastdiscount &&
                    Object.keys(productPrices?.lastdiscount).length > 0 &&
                    productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                    let result = productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name];
                    if (!parameterDetails?.discountRate && result?.amount) {
                        setLineDiscountAmount(result?.amount || '');
                    }
                    if (parameterDetails?.discountRate && result?.rate) {
                        setLineDiscountRate(result?.rate || '');
                    }
                    if (result?.percent) {
                        setLineDiscountPercentage(result?.percent || '');
                    }
                } else {
                    setLineDiscountAmount('');
                    setLineDiscountPercentage('');
                }
            }
        } else {
            if (!lineEdit) {
                setLineDiscountAmount('');
                setLineDiscountPercentage('');
                if (parameterDetails?.productUnitPrice) {
                    let d = customObject(myProductdetails, lineProductId);
                    if (d) {
                        setLineUseMrp(d?.useMrp);
                        setLinePrice(d?.costPrice || '');
                        setLineMrp(d?.mrp || '');
                    }
                }
            }
        }
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyDescription = emptyValidation('Description', lineDescription);
        let emptyUnit = emptyValidation('Unit', lineUnitId, 'dropDown');
        let emptyPrice = emptyValidation('Price', linePrice);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineQuantity);
        let emptyAmount = emptyValidation('Line Amount', lineAmount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineProductGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineHsnId, 'dropDown');
        if ((lineIncludeGst && !emptyProductGst.isValid) || (lineIncludeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }

        // let checkExcises = true;
        // let emptyExcisesAmount = emptyValidation(lineExcisesType === 'perUnit' ? 'Excise Rate' : 'Excise Amount', lineExcisesType === 'perUnit' ? lineExcisesRate : lineExcisesAmount);
        // if (lineExcisesApplicable) {
        //     if (!emptyExcisesAmount.isValid) {
        //         checkExcises = false;
        //     }
        // }

        // let checkSplExcises = true;
        // let emptySplExcisesAmount = emptyValidation(lineSplExcisesType === 'perUnit' ? 'SPL Excise Rate' : 'SPL Excise Amount', lineSplExcisesType === 'perUnit' ? lineSplExcisesRate : lineSplExcisesAmount);
        // if (lineExcisesApplicable) {
        //     if (!emptySplExcisesAmount.isValid) {
        //         checkSplExcises = false;
        //     }
        // }


        let discountAgreeMents = true;
        let total = lineQuantity * linePrice;
        if (Math.abs(total) < Math.abs(lineDiscountCalcAmount)) {
            discountAgreeMents = false;
        }

        let batchDetails = [];
        if (selectedBatchId?.length > 0) {
            let seBatch = batch.filter(el => selectedBatchId.includes(el.id));
            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                batchDetails.push({
                    batchId: el.id,
                    batch: el,
                    quantity: el.soldQuantity,
                    discountAmount: el.discountAmount
                })
            })
        }

        let freeBatchDetails = [];
        if (freeProduct?.quantitySpec === 'MIX & MATCH' && selectedFreeBatchId?.length > 0) {
            let seBatch = freeBatch.filter(el => selectedFreeBatchId.includes(el.id));
            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                freeBatchDetails.push({
                    batchId: el.id,
                    batch: el,
                    quantity: el.soldQuantity,
                    discountAmount: el.discountAmount
                })
            })
        }

        let negativeQuantityCheck = { isValid: true, errors: '' };
        if (lineProductId && type === 'self-bill' && !parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let qty = availableQuantity - Math.abs(lineQuantity);
            if (qty < 0) {
                negativeQuantityCheck = { isValid: false, errors: 'There is no stocks available' }
            }
            if (freeProduct?.id && freeProduct?.quantitySpec === 'SAME ITEM') {
                let lQty = Math.abs(lineQuantity) + Math.abs(freeProduct?.freeQty);
                let tQty = availableQuantity - Math.abs(lQty);
                if (tQty < 0) {
                    negativeQuantityCheck = { isValid: false, errors: 'No stock available for the free product.' }
                }
            }
        }

        let negativeFreeQuantityCheck = { isValid: true, errors: '' };
        if (freeProduct?.id && type === 'self-bill' && !parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let qty = freeAvailableQuantity - Math.abs(freeProduct?.freeQty);
            if (qty < 0) {
                negativeFreeQuantityCheck = { isValid: false, errors: 'There is no stocks available' }
            }
        }



        let batchQuantityError = { isValid: true, errors: '' };
        if (batchDetails?.length > 0) {
            let batchQuantity = batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineQuantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Selected Batch quantity should equal Line Quantity' }
            }
        }

        let freeBatchQuantityError = { isValid: true, errors: '' };
        if (freeBatchDetails?.length > 0) {
            let freeBatchQuantity = freeBatchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
            if (freeBatchQuantity !== parseFloat(freeProduct?.freeQty)) {
                freeBatchQuantityError = { isValid: false, errors: 'Total Selected Batch quantity should equal Line Quantity' }
            }
        }


        let productError = { isValid: true, errors: '' };
        // if (lineId === '' && lineProductId && lines.some(line => line.productId === lineProductId)) {
        //     let lId = lineProductId && lines.find(line => line.productId === lineProductId);
        //     productError = { isValid: false, errors: `Product added in Line "${lId}". Goto the Line "${lId}" to update quantity` };
        // }

        if (batchDetails?.length > 0 && lineId === '' && lineProductId) {
            const existingIndex = lines.findIndex(line => line.productId === lineProductId);
            if (existingIndex !== -1) {
                productError = {
                    isValid: false,
                    errors: `Product already exists in line ${existingIndex + 1}. Go to line ${existingIndex + 1} to update quantity.`
                };
            }
        }

        emptyLineState();
        if (emptyDescription.isValid && emptyUnit.isValid && discountAgreeMents &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && negativeFreeQuantityCheck.isValid &&
            checkValidation && batchQuantityError.isValid && freeBatchQuantityError.isValid && negativeQuantityCheck.isValid && productError.isValid) {
            let mLines = {
                description: lineDescription,
                quantity: parseFloat(lineQuantity),
                unitId: lineUnitId,
                pricePerUnit: linePrice,
                amount: lineAmount,
                includeGst: lineIncludeGst,
                discountAmount: lineDiscountAmount ? lineDiscountAmount : 0,
                discountPercent: lineDiscountPercentage ? lineDiscountPercentage : 0,
                gstAmount: parseFloat(lineGstAmount),
                cgst: lineCgstAmount ? parseFloat(lineCgstAmount) : 0,
                sgst: lineSgstAmount ? parseFloat(lineSgstAmount) : 0,
                igst: lineIgstAmount ? parseFloat(lineIgstAmount) : 0,
                cgstPercentage: lineCgst,
                igstPercentage: lineIgst,
                sgstPercentage: lineSgst,
                maxRetailPrice: lineMrp,
                locationId: lineLocationId || '',
                costPrice: lineCostPrice || '',
                excisesApplicable: lineExcisesApplicable || false,
                stockQuantity: lineStock?.quantity || null,
                stockUnitId: lineStock?.unitId || null,
                salesValue: lineSalesValue || null,
                discountType: lineDiscountType || null,
                discountRate: lineDiscountRate || null
            };
            let mFreeLines = {};

            if (lineExcisesApplicable) {
                mLines['excisesType'] = lineExcisesType;
                mLines['excisesRate'] = lineExcisesRate;
                mLines['excisesAmount'] = lineExcisesAmount;
                mLines['excisesSplType'] = lineSplExcisesType;
                mLines['excisesSplRate'] = lineSplExcisesRate;
                mLines['excisesSplAmount'] = lineSplExcisesAmount || '';
                mLines['excisesAddAmount'] = lineAddExcisesAmount || '';
                mLines['excisesTotal'] = lineExcisesTotal;
                mLines['totalCostPrice'] = lineTotalCostPrice || '';
            }


            if (selectedBatchId?.length > 0) {
                let seBatch = batch.filter(el => selectedBatchId.includes(el.id));
                let batchDetails = [];
                seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                    batchDetails.push({
                        batchId: el.id,
                        batch: el,
                        quantity: el.soldQuantity,
                        discountAmount: el.discountAmount
                    })
                })
                mLines['batchDetails'] = batchDetails;
            }

            if (lineProductGstId) {
                mLines["productGstId"] = lineProductGstId;
            }

            if (lineUniversalProductId) {
                mLines["universalProductId"] = lineUniversalProductId;
            }

            if (lineHsnId) {
                mLines["hsnId"] = lineHsnId;
                mLines.hsn = customObject(hsnDetails, lineHsnId);
            }

            if (lineProductId) {
                mLines["productId"] = lineProductId;
                let d = customObject(myProductdetails, lineProductId);
                mLines["product"] = d;
                if (d && d?.categoryId) {
                    mLines["productCategoryId"] = d?.categoryId;
                }
            }

            if (freeProduct?.id) {
                let code = Math.floor(1000 + Math.random() * 9000);
                mLines['freeProductLineNumber'] = code;
                mFreeLines = {
                    productId: freeProduct?.freeItem?.id,
                    description: freeProduct?.freeItem?.description || freeProduct?.freeItem?.productName || '',
                    quantity: parseFloat(freeProduct?.freeQty),
                    unitId: freeProduct?.freeUnitId,
                    pricePerUnit: 0,
                    amount: 0,
                    includeGst: false,
                    discountAmount: 0,
                    discountPercent: 0,
                    gstAmount: 0,
                    cgst: 0,
                    sgst: 0,
                    igst: 0,
                    cgstPercentage: 0,
                    igstPercentage: 0,
                    sgstPercentage: 0,
                    maxRetailPrice: 0,
                    locationId: lineLocationId || '',
                    parentLineNumber: code
                }
                if (lineHsnId) {
                    mFreeLines["hsnId"] = lineHsnId;
                    mFreeLines.hsn = customObject(hsnDetails, lineHsnId);
                }
                if (lineProductGstId) {
                    mFreeLines["productGstId"] = lineProductGstId;
                }
                if (freeProduct?.quantitySpec === 'SAME ITEM' && freeProduct?.freeItem?.batchActivation) {
                    let freeBatch = batch.filter(item => (item.availableStock - item.soldQuantity) !== 0);
                    if (freeBatch?.length > 0) {
                        freeBatch = freeBatch.map(item => ({
                            ...item,
                            availableStock: item.availableStock - item.soldQuantity,
                            soldQuantity: 0
                        }));
                        let freeBatchIds = findCombination(freeBatch.filter(el => el.locationId === lineLocationId), freeProduct?.freeQty).changedItems;
                        freeBatch = findCombination(freeBatch.filter(el => el.locationId === lineLocationId), freeProduct?.freeQty).updatedItems;
                        if (freeBatchIds?.length > 0) {
                            let seBatch = freeBatch.filter(el => freeBatchIds.includes(el.id));
                            let freeBatchDetails = [];
                            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                freeBatchDetails.push({
                                    batchId: el.id,
                                    batch: el,
                                    quantity: el.soldQuantity,
                                    discountAmount: el.discountAmount
                                })
                            });
                            if (freeBatchDetails?.length > 0) {
                                let freeBatchQuantity = freeBatchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
                                if (freeBatchQuantity !== parseFloat(freeProduct?.freeQty)) {
                                    toast.dismiss();
                                    toast.error('Insufficient stock for free item'); return true;
                                }
                            }
                            mFreeLines['batchDetails'] = freeBatchDetails;
                        }
                    }
                } else {
                    if (selectedFreeBatchId?.length > 0) {
                        let seBatch = freeBatch.filter(el => selectedFreeBatchId.includes(el.id));
                        let freeBatchDetails = [];
                        seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                            freeBatchDetails.push({
                                batchId: el.id,
                                batch: el,
                                quantity: el.soldQuantity,
                                discountAmount: el.discountAmount
                            })
                        })
                        mFreeLines['batchDetails'] = freeBatchDetails;
                    }
                }
            }

            if (lineId !== '') {
                // let index = lines.findIndex((d, i) => lineId === i);
                // let findLine = lines.find((d, i) => lineId === i);
                // if (index >= 0) {
                //     lines.splice(index, 1, mLines);
                //     if (findLine?.freeProductLineNumber) {
                //         let fIndex = lines.findIndex((d, i) => d?.parentLineNumber === findLine?.freeProductLineNumber);
                //         if (fIndex >= 0)
                //             lines.splice(fIndex, 1, mFreeLines)
                //     }
                // }
                const index = Number(lineId);

                setLines(prev => {
                    const newLines = [...prev];
                    // Update main line
                    if (index >= 0 && index < newLines.length) {
                        const oldLine = newLines[index];
                        newLines[index] = mLines;
                        // If old line had a free product line, update it too
                        if (oldLine?.freeProductLineNumber) {
                            const fIndex = newLines.findIndex(
                                d => d?.parentLineNumber === oldLine.freeProductLineNumber
                            );
                            if (fIndex >= 0) newLines[fIndex] = mFreeLines;
                        }
                    }
                    return newLines;
                });
            } else {
                setLines(prev => {
                    const newLines = [...prev, mLines];
                    // Add free line only when it is valid (not empty)
                    if (mFreeLines?.productId) {
                        newLines.push(mFreeLines);
                    }
                    return newLines;
                });
            }

            handleClose();
            if (more) {
                setTimeout(function () {
                    setVisible(true);
                    setLineNumber(parseInt(lines.length + 2));
                    setLineLocationId(lineLocationId);
                }, 500)
            }
            childRef?.current?.handleAdjustHeight();
        } else {
            if (emptyDescription.errors) {
                setErrorLineDescription(emptyDescription.errors);
            }
            if (productError.errors) {
                setErrorLineDescription(productError.errors);
            }
            // if (!checkExcises) {
            //     setErrorLineExcisesAmount(emptyExcisesAmount?.errors || '');
            // }
            // if (!checkSplExcises) {
            //     setErrorLineSplExcisesAmount(emptySplExcisesAmount?.errors || '');
            // }
            if (emptyUnit.errors) {
                setErrorLineUnitId(emptyUnit.errors);
            }
            if (!discountAgreeMents) {
                setErrorDiscountAgreements('Discount amount is greater than Line amount, please correct it.');
            }
            if (negativeFreeQuantityCheck?.errors || freeBatchQuantityError.errors) {
                setShowFreeProduct(true);
                setErrorFreeBatchQuantity(negativeFreeQuantityCheck?.errors || freeBatchQuantityError.errors);
            }
            if (emptyPrice.errors) {
                setErrorLinePrice(emptyPrice.errors);
            }
            if (emptyQuantity.errors || negativeQuantityCheck.errors) {
                setErrorLineQuantity(emptyQuantity.errors || negativeQuantityCheck.errors);
            }
            if (batchQuantityError.errors) {
                setErrorBatchQuantity(batchQuantityError.errors);
            }
            // if (emptyAmount.errors) {
            //     setErrorLineAmount(emptyAmount.errors);
            // }
            if (lineIncludeGst && !emptyProductGst.isValid) {
                setErrorLineProductGst(emptyProductGst.errors);
            }
            if (lineIncludeGst && !emptyHsn.isValid) {
                setErrorLineHsn(emptyHsn.errors);
            }
        }
    }

    const handleModalClose = (o) => {
        setOpen(o); setPreview(false);
    };

    const onEdit = async (data, i) => {
        if (!customerId) {
            toast.dismiss();
            toast.error('Please Select Customer.'); return true;
        }
        setPrimaryTitle('Edit');
        setLineId(i);
        setLineNumber(parseInt(i + 1));
        setLineProductId(data?.productId || '');
        setLineLocationId(data?.locationId || '');
        setLineDescription(data?.description || '');
        setLineQuantity(data?.quantity || 0);
        setLineUnitId(data?.unitId || '');
        setLineStock({
            unitId: data?.stockUnitId || '',
            quantity: data?.stockQuantity || '',
            unit: data?.stockUnit || ''
        });
        setProductLineUnitId(data?.unitId || '');
        setLinePrice(data?.pricePerUnit || 0);
        setLineDiscountType(data?.discountType || '');
        setLineDiscountRate(data?.discountRate || '');
        setLineDiscountAmount(data?.discountAmount || '');
        setLineDiscountPercentage(data?.discountPercent || '');
        setLineIncludeGst(data.includeGst ? true : false);
        setLineProductGstId(data?.productGstId || '');
        setLineHsnId(data?.hsnId || '');
        setLineMrp(data?.maxRetailPrice || '');
        setLineSalesValue(data?.salesValue || '');
        setLineCostPrice(data?.product?.costPrice || data?.costPrice || '');
        hsnApi('', data?.hsnId || '');
        productApi('', data?.productId || '');
        locationApi();
        setVisible(true);
        setLineEdit(true);

        setAutoMark(false);
        let batch = [];
        if (data?.productId) {
            batch = await getProductBatch(data?.productId);
            // getAvailableQty(data?.productId, data?.unitId);
        }

        if (data?.batchDetails && data?.batchDetails?.length > 0) {
            setBatchDetails(data?.batchDetails);
            let a = [];
            data?.batchDetails?.map((el) => {
                a.push(el.batchId);
            });

            const updatedBatches = batch.map(batch => {
                const saleBatch = data?.batchDetails.find(s => s.batchId === batch.id);
                return {
                    ...batch,
                    soldQuantity: saleBatch ? saleBatch.quantity : batch.soldQuantity
                };
            });

            setBatch(updatedBatches);
            setSelectedBatchId(a);
            getAvailableQty(data?.productId, data?.unitId, data?.locationId, updatedBatches, false, true);
        } else {
            getAvailableQty(data?.productId, data?.unitId, data?.locationId, [], false, true);
        }

        if (data?.productId && data?.quantity) {
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/saledprice/${customerId}/${data.productId}/${Math.abs(parseInt(data.quantity))}`
            });
        }
        if (data.productId) {
            checkFreeProduct(data.productId, data?.quantity, data?.locationId);
        }

        setLineExcisesApplicable(data?.excisesApplicable || false);

        if (data?.excisesApplicable) {
            setLineExcisesAmount(data?.excisesAmount);
            setLineExcisesType(data?.excisesType);
            setLineSplExcisesType(data?.excisesSplType)
            setLineExcisesRate(data?.excisesRate);
            setLineSplExcisesRate(data?.excisesSplRate);
            setLineSplExcisesAmount(data?.excisesSplAmount);
            setLineAddExcisesAmount(data?.excisesAddAmount);
        }
    }


    const getProductBatch = async (id) => {
        try {
            let f = { where: { ["and"]: [{ productId: id }, { availableStock: { gt: 0 } }] } };
            if (creditNote) {
                f = { where: { ["and"]: [{ productId: id }, { soldQuantity: { gt: 0 } }] } };
            }
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${id}?filter=${encodeURIComponent(JSON.stringify(f))}`);
            const data = response.data;
            let val = [];
            if (data && data.length) {
                val = data.map(item => ({
                    ...item,
                    availableStock: type === 'self-bill' ? item.availableStock : -item.soldQuantity,
                    fakeAvailableStock: type === 'self-bill' ? item.availableStock : -item.soldQuantity,
                    soldQuantity: 0,
                    originalSoldQuantity: 0
                }));
                setViewBatch(true);
            } else {
                val = [];
                setViewBatch(false);
            }

            setBatch(val);
            setAutoMark(false);
            return val;
        } catch (error) {
            setViewBatch(false);
            setBatch([]);
            setAutoMark(false);
            return [];
        }
    }

    const handleProductChange = async (data) => {
        setLineEdit(false);
        setLineProductId(data?.id);
        setLineDescription(data?.description || data?.productName || '');
        setLineUnitId(data?.defaultSalesUnitId || data?.salesUnitId || '');
        setProductLineUnitId(data?.defaultSalesUnitId || data?.salesUnitId || '');
        setLineUniversalProductId(data?.universalProductId || '');
        setLineCostPrice(data?.costPrice || '');
        setLineCess(true);
        // if (lineQuantity && lineQuantity !== '') {
        //     dispatch({
        //         type: productActions.PRODUCT_PRICE_START,
        //         url: `/saledprice/${customerId}/${id}/${lineQuantity}`
        //     });
        // }
        dispatch({
            type: productActions.PRODUCT_PRICE_START,
            url: `/saledprice/${customerId}/${data?.id}/${lineQuantity && lineQuantity !== '' ? Math.abs(lineQuantity) : 1}`
        });

        if (parameterDetails?.inventoryTransaction) {
            let batch = await getProductBatch(data?.id);
            getAvailableQty(data?.id, data?.salesUnitId, lineLocationId, batch);
        }

        unstable_batchedUpdates(() => {
        if (includeGst) {
            setLineProductGstId(data?.productGstId || '');
            setLineHsnId(data?.hsnId || '');
            if (data?.hsnId) {
                hsnApi('', data?.hsnId);
            }
        }

        setLineExcisesApplicable(data?.exciseApplicable || false);
        if (!data?.productGstId && data?.exciseApplicable) {
            setLineIncludeGst(false);
        }
        });
    }

    const checkFreeProduct = (productId, quantity, locationId) => {
        // let filter = { "and": [{ saleItemId: productId }] };
        // let or = { "or": [] };
        // filter['and'].push({ fromDate: { gte: moment().format('YYYY-MM-DD') } });
        // filter['and'].push({ toDate: { lte: moment().format('YYYY-MM-DD') } });
        // or['or'].push({ customerId: customerId });
        // if (customerDetails?.groupId)
        //     or['or'].push({ customerGroupId: customerDetails?.groupId });
        // filter['and'].push(or);

        // filter = { where: filter, order: 'id desc' };
        getRequest(`${process.env.REACT_APP_API_URL}/sales-quantities-search/${customerId}/${productId}/${quantity}`)
            // getRequest(`${process.env.REACT_APP_API_URL}/sales-quantities/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(async uResponse => {
                if (uResponse?.data && uResponse?.data?.length > 0) {
                    let datass = uResponse?.data[0];
                    datass.freeQty = Math.floor((quantity / datass.salesQty) * datass.freeQty);
                    setFreeProduct(datass || {});

                    const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${datass?.freeItemId}/${datass?.freeUnitId}/${locationId}`);
                    const data = response.data;
                    // let val = [];
                    if (data?.length && data[0]?.units?.length) {
                        let qty = data[0]?.units.find(obj => obj.hasOwnProperty(datass?.freeUnitId))?.[datass?.freeUnitId];
                        setFreeAvailableQuantity(parseFloat(parseFloat(qty).toFixed(2)));
                    } else {
                        setFreeAvailableQuantity(0);
                    }
                    if (datass?.quantitySpec === 'MIX & MATCH' && datass?.freeItem?.batchActivation) {
                        try {
                            let f = { where: { ["and"]: [{ productId: datass?.freeItem?.id }, { availableStock: { gt: 0 } }] } };

                            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${datass?.freeItem?.id}?filter=${encodeURIComponent(JSON.stringify(f))}`);
                            const data = response.data;
                            let val = [];
                            if (data && data.length) {
                                val = data.map(item => ({
                                    ...item,
                                    availableStock: item.availableStock,
                                    fakeAvailableStock: item.availableStock,
                                    soldQuantity: 0,
                                    originalSoldQuantity: 0
                                }));
                            } else {
                                val = [];
                            }
                            setSelectedFreeBatchId(findCombination(val.filter(el => el.locationId === locationId), datass?.freeQty).changedItems);
                            setFreeBatch(findCombination(val.filter(el => el.locationId === locationId), datass?.freeQty).updatedItems);
                            return val;
                        } catch (error) {
                            setFreeBatch([]);
                            return [];
                        }
                    }
                }
                else {
                    setFreeProduct({});
                }
            }).catch(error => {
                console.error("Error fetching data", error);
            });
    }


    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultSalesUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }
                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(filtered);
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    const handleStockUnits = (productId, unitId, quantity) => {
        if (productId && unitId && quantity) {
            setStockLoading(true);
            getRequest(`${process.env.REACT_APP_API_URL}/check-stock-units/?productId=${productId}&unitId=${unitId}&quantity=${quantity}`)
                .then(response => {
                    let data = response.data;
                    unstable_batchedUpdates(() => {
                        setLineStock(data);
                        setStockLoading(false);
                    });
                }).catch(error => {
                    console.error("Error fetching data", error);
                    setStockLoading(false);
                });
        }
    }

    const getAvailableQty = async (id, unitId, locationId, batch, view = false, edit = false) => {
        try {
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${id}/${unitId}/${locationId}`);
            const data = response.data;
            // let val = [];
            unstable_batchedUpdates(() => {
            if (data?.length && data[0]?.units?.length) {
                let qty = data[0]?.units.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                if (edit) {
                    setAvailableQuantity(parseFloat(parseFloat(qty).toFixed(2)));
                } else {
                    const totalQuantity = lines && lines?.length ? lines?.filter(line => line.productId === id).reduce((sum, line) => sum + parseFloat(line.quantity || 0), 0) : 0;
                    setAvailableQuantity(parseFloat(parseFloat(qty - totalQuantity).toFixed(2)));
                }
            } else {
                setAvailableQuantity(0);
            }


            if (data?.length && data[0]?.cPrice?.length) {
                let qty = data[0]?.cPrice.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                setLineCostPrice(parseFloat(parseFloat(qty).toFixed(2)));
            } else {
                setLineCostPrice(0);
            }
            if (data?.length && data[0]?.cUnits?.length) {
                let qty = data[0]?.cUnits.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                let divied = data[0]?.cUnits.find(obj => obj.hasOwnProperty(unitId)).divied;
                let a = [];
                batch?.length > 0 && batch.map((el, i) => {
                    el.availableStock = divied ? parseFloat(parseFloat(el.fakeAvailableStock / qty).toFixed(2)) : parseFloat(parseFloat(qty * el.fakeAvailableStock).toFixed(2));
                    el.soldQuantity = view ? 0 : el.soldQuantity;
                    el.originalSoldQuantity = view ? 0 : el.originalSoldQuantity;
                    a.push(el);
                });
                setBatch(a);
                if (view) {
                    setSelectedBatchId([])
                }
            }
            });
        } catch (error) {
            console.log(error);
        }
    }


    const onEditButton = () => {
        setViewVisible(false);
        setVisible(true);
    }

    const onView = async (data, i) => {
        if (!customerId) {
            toast.dismiss();
            toast.error('Please Select Customer'); return true;
        }
        console.log(data);
        setLineEdit(true);
        setLineId(i);
        setViewVisible(true);
        setLineNumber(parseInt(i + 1));
        setLineProductId(data?.productId || '');
        setLineLocationId(data?.locationId || '');
        setLineDescription(data?.description || '');
        setLineQuantity(data?.quantity || 0);
        setLineUnitId(data?.unitId || '');
        setLineStock({
            unitId: data?.stockUnitId || '',
            quantity: data?.stockQuantity || '',
            unit: data?.stockUnit || ''
        });
        setProductLineUnitId(data?.unitId || '');
        setLinePrice(data?.pricePerUnit || 0);
        setLineAmount(data?.amount || 0);
        setLineDiscountAmount(data?.discountAmount || 0);
        setLineDiscountType(data?.discountType || '');
        setLineDiscountRate(data?.discountRate || '');
        setLineDiscountPercentage(data?.discountPercent || 0);
        setLineIncludeGst(data.includeGst ? true : false);
        setLineProductGstId(data?.productGstId || '');
        setLineHsnId(data?.hsnId || '');
        productApi('', data?.productId || '');
        locationApi();
        hsnApi('', data?.hsnId || '');
        setLineMrp(data.maxRetailPrice ? data.maxRetailPrice : '');
        setLineSalesValue(data?.salesValue || '');
        setLineCostPrice(data?.product?.costPrice || data?.costPrice || '');
        setAutoMark(false);
        let batch = [];
        if (data?.productId) {
            batch = await getProductBatch(data?.productId);
        }

        if (data?.batchDetails && data?.batchDetails?.length > 0) {
            setBatchDetails(data?.batchDetails);
            let a = [];
            data?.batchDetails?.map((el) => {
                a.push(el.batchId);
            });
            const updatedMatchedBatches = batch
                .filter(batch => data?.batchDetails.some(sale => sale.batchId === batch.id))
                .map(batch => {
                    const matchedSale = data?.batchDetails.find(sale => sale.batchId === batch.id);
                    return {
                        ...batch,
                        soldQuantity: matchedSale.quantity
                    };
                });

            setBatch(updatedMatchedBatches);
            setSelectedBatchId(a);
            getAvailableQty(data?.productId, data?.unitId, data?.locationId || '', updatedMatchedBatches, false, true);
        } else {
            getAvailableQty(data?.productId, data?.unitId, data?.locationId || '', [], false, true);
        }

        if (data?.productId && data.quantity) {
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/saledprice/${customerId}/${data.productId}/${Math.abs(data.quantity)}`
            });
        }

        if (data?.productId) {
            checkFreeProduct(data.productId, data?.quantity, data?.locationId);
        }
        setLineExcisesApplicable(data?.excisesApplicable || false);
        console.log(data);
        if (data?.excisesApplicable) {
            setLineExcisesAmount(data?.excisesAmount);
            setLineExcisesType(data?.excisesType);
            setLineSplExcisesType(data?.excisesSplType)
            setLineExcisesRate(data?.excisesRate);
            setLineSplExcisesRate(data?.excisesSplRate);
            setLineSplExcisesAmount(data?.excisesSplAmount);
            setLineAddExcisesAmount(data?.excisesAddAmount);
        }
    }

    const changeHandlerBatch = (data, e, name) => {
        const newTodos = batch.map((el) => {
            if (el.batchNumber === data.batchNumber) {
                return { ...el, [name]: e };
            }
            return el;
        });
        setBatch(newTodos);
    }


    const handleProductPrice = (key) => {
        let a = unitMesurementdetails && unitMesurementdetails.filter(function (el) { return el.name === key });
        if (a && a?.length !== 0) {
            setLineUnitId(a[0]?.id);
            setProductLineUnitId(a[0]?.id);
            if (lineProductId !== '') {
                let productData = customObject(myProductdetails, lineProductId);
                setLineUseMrp(productData?.salesUnitId !== a[0]?.id ? false : productData?.useMrp);
            }
        }
        if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
            productPrices?.lastprice[key]) {
            let result = productPrices?.lastprice[key];
            setLinePrice(result?.price);
            if (result?.mrp) {
                setLineMrp(result?.mrp);
            }
        }
        setUnitPriceList(false);
        setUnitPriceFocusList(false);
    }

    const deleteLine = () => {
        let index = lines.findIndex((d, i) => lineId === i);
        let findLine = lines.find((d, i) => lineId === i);
        if (index >= 0) {
            lines.splice(index, 1);
            if (findLine.freeProductLineNumber) {
                let fIndex = lines.findIndex((d, i) => findLine.freeProductLineNumber === d.parentLineNumber);
                lines.splice(fIndex, 1);
            }
        }
        setIsModalVisible(false);
    }

    const onDelete = (data, i) => {
        setIsModalVisible(true);
        setLineId(i);
        setLineDescription(data.description);
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            setPreviewData({});
            setPreview(false);
            setConfirm(false);
            toast.dismiss();
            // toast(createDetails);
            if (status === 'CONFIRMED') {
                setOpen(true);
            } else {
                if (selfBillCustomerId && decryptedId) {
                    history.push(`/sales/sales-management/self-bill/${AESEncrypt(createData?.id)}/${selfBillCustomerId}/view`, 'create');
                } else {
                    history.push(`/sales/sales-management/self-bill/${AESEncrypt(createData?.id)}/view`, 'create');
                }
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError?.error?.message?.message || createError.error.message;
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (locationDetails && locationDetails?.length > 0 && lineLocationId === '') {
            let a = locationDetails?.filter(el => el.default);
            if (a?.length > 0) {
                setLineLocationId(a[0]?.id);
            } else {
                setLineLocationId(locationDetails[0]?.id);
            }
        }
    }, [locationDetails]);


    const changeCustomer = (value) => {
        unstable_batchedUpdates(() => {
        if (value?.isHold) {
            setErrorCustomerId('Please release the Customer from ON-HOLD to allow for transaction to be processed.');
            setCustomerId('');
            setCustomerDetail('');
            setName('');
            setCustomerSerialNo('');
            setAreaId('');
            setSalesRepId('');
            setGstCodeId('');
            setPincodeId('');
            setCityId('');
            setCashDiscountAmount('');
            setCashDiscountId('');
            setStateId('');
            setCountryId('');
            setCurrencyId('');
            setMopId('');
            setAddress('');
            setEmail('');
            setTaxCodeId('');
            setTcsNameId('');
            setMobile('');
            setInAppStatus('');
            setInAppTransition(false);
            setPriceIncludesTax(false);
            setIncludeGst(false);
        } else {
            setErrorCustomerId(false);
            if (value?.stateId) {
                changeStateApi(value?.stateId);
            }

            if (value?.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: value?.pincodeId }] }
                    }
                });
            }
            setCustomerDetail(value);
            setCustomerId(value.id);
            setName(value.name);
            setCustomerSerialNo(value.serialNo);
            setAreaId(value.areaId);
            setSalesRepId(value?.salesRepId || '');
            setPriceIncludesTax(value?.priceIncludesTax || false);
            setGstCodeId(value.partyGstId && value?.partyGstId > 0 ? value?.partyGstId : '');
            setPincodeId(value.pincodeId);
            setCityId(value.cityId);
            setStateId(value.stateId);
            setCountryId(value.countryId);
            setCurrencyId(value.currencyId);
            setTaxCodeId(value?.taxCodeId || '');
            setTcsNameId(value?.tcsId || '');
            setMopId(value.mopId > 0 ? value.mopId : '');
            setAddress(value.address1);
            setEmail(value?.email || '');
            setMobile(value.mobile);
            setCashDiscountId(value?.cashDiscountId || '');
            setInAppStatus(value.inAppStatus);
            setInAppTransition(value.inAppStatus === 'ACCEPTED' ? value.inAppTransition : false);
            gstSettings(businessDetails, value);
        }
        });
        return [];
    }

    const gstSettings = (businessDetails, value) => {
        let gstSetting = includeGstSettings(businessDetails, value);
        setIncludeGst(gstSetting.includeGst);
        setIncludeDisabled(gstSetting.includeDisabled);
    }

    const changeArea = (value) => {
        setAreaId(value);
    }

    const customObject = (details, id) => {
        if (!Array.isArray(details) || details.length === 0 || id === '' || id === undefined || id === null) {
            return EMPTY_RESULT;
        }
        let idMap = objectIdCache.get(details);
        if (!idMap) {
            idMap = new Map();
            for (let i = 0; i < details.length; i++) {
                const el = details[i];
                if (el && !idMap.has(el.id)) {
                    idMap.set(el.id, el);
                }
            }
            objectIdCache.set(details, idMap);
        }
        return idMap.has(id) ? idMap.get(id) : EMPTY_RESULT;
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);
    }


    const handleLineIncludeGst = (value) => {
        setLineIncludeGst(value);
        setErrorLineProductGst(false);
        if (value && lineIncludeGst !== '') {
            let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === gstCodeId });
            if (party.length !== 0) {
                let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === lineProductGstId });
                if (p && p.length !== 0) {
                    let percentage = p[0].percentage;
                    let details = {
                        percentage: percentage,
                        stateId: stateId,
                        lineAmount: lineAmount, priceIncludesTax: priceIncludesTax
                    };
                    let gstCalc = gstCalculation(businessDetails, details, customerDetail);
                    setLineCgst(parseFloat(gstCalc?.cgst || 0));
                    setLineSgst(parseFloat(gstCalc.sgst || 0));
                    setLineCgstAmount(parseFloat(gstCalc.cgstAmount || 0));
                    setLineSgstAmount(parseFloat(gstCalc.sgstAmount || 0));
                    setLineIgst(parseFloat(gstCalc.igst || 0));
                    setLineIgstAmount(parseFloat(gstCalc.igstAmount || 0));
                    setLineGstAmount(parseFloat(gstCalc.gAmount || 0));
                }
            }
        } else {
            setLineGstAmount(0);
            setLineCgst(0);
            setLineSgst(0);
            setLineIgst(0);
            setLineCgstAmount(0);
            setLineSgstAmount(0);
            setLineIgstAmount(0);
        }
    }

    const shouldBlur = (e) => {
        // let unit = customObject(unitMesurementdetails, lineUnitId);        
        // if(!unit?.precision) {            
        //     if(e.key === '.') {
        //         return false
        //     }          
        // }
        if (e.keyCode === 9) {
            setUnitPriceList(false)
        }
    }

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter((el) => { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }
                }
            });
        }
        return [];
    }

    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter((el) => { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            setCurrencyId(a[0].country && a[0].country.currencyId);
        }
        changeStateApi(value);
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const changeLineHsn = (value) => {
        setLineHsnId(value);
        // let a = hsnDetails && hsnDetails.filter(function (el) { return el.id === value });
        // if (a && a?.length !== 0) {
        //     setLineProductGstId(a[0].productGstId);
        // }
    }

    const handleProductTextChange = (value) => {
        if (value === '') {
            setLineDescription('');
            setLineUnitId('');
            setProductLineUnitId('');
            setLineUseMrp('');
            setLineMrp();
            setLineCostPrice('');
            setLineUniversalProductId('');
            setLineProductId('');
            dispatch({ type: productActions.CLEAR_PRICE_START });
            if (includeGst) {
                setLineProductGstId('');
                setLineHsnId('');
            }
        }
    }

    const handleLineUnit = (data) => {
        setLineUnitId(data.id);
        getAvailableQty(lineProductId, data.id, lineLocationId, batch, true, lineEdit);
        handleSetProductPrice(data.id, false);
        handleStockUnits(lineProductId, data.id, lineQuantity);
    }

    const handleQuantityChange = (value) => {
        if (lineProductId && lineProductId !== '' && value && value !== '') {
            if (priceRef.current !== null) {
                clearTimeout(priceRef.current);
            }
            priceRef.current = setTimeout(() => {
                setLineEdit(false);
                priceRef.current = null;
                dispatch({
                    type: productActions.PRODUCT_PRICE_START,
                    url: `/saledprice/${customerId}/${lineProductId}/${Math.abs(value)}`
                });
                if (lineProductId) {
                    checkFreeProduct(lineProductId, Math.abs(value), lineLocationId);
                    handleStockUnits(lineProductId, lineUnitId, Math.abs(value));
                }
            }, 500);
        }
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }

        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }



    const handleCustomerProductsOpen = () => {
        setProductsVisible(true);
    }

    const handleBulkLineSubmit = (selected) => {
        setLines(selected);
        setProductsVisible(false);
    }

    const handleRoundOff = (data) => {
        setRoundOffMethod(data.id);
        let value = 0;
        if (totalInvoice && data?.id) {
            if (data.id === 'UP') {
                value = Math.ceil(totalInvoice);
            } else {
                value = Math.floor(totalInvoice);
            }
            setRoundOffAmount(parseFloat(parseFloat(value - totalInvoice).toFixed(2)));
            setTotal(parseFloat(parseFloat(value).toFixed(2)));
        } else {
            setRoundOffAmount(0);
            setTotal(parseFloat(parseFloat(totalInvoice).toFixed(2)));
        }
    }

    const classes = customStyles();


    const handleClick = (id) => {
        const isSelected = selectedBatchId.includes(id);
        let newSelected;

        if (!isSelected) {
            // Checked (select)
            newSelected = [...selectedBatchId, id];

        } else {
            // UnChecked (deselect)
            newSelected = selectedBatchId.filter(batchId => batchId !== id);
        }

        if (!creditNote && updateSoldQty(newSelected, id, !isSelected)) {
            setSelectedBatchId(newSelected);
        } else if (creditNote && updateSoldQtyCredit(newSelected, id, !isSelected)) {
            setSelectedBatchId(newSelected);
        }
    };

    const updateSoldQtyCredit = (newSelected, id, isChecked) => {
        const limit = parseFloat(lineQuantity); // Ex: -20

        // Get total sold quantity from selected batches
        const selectedBatches = batch.filter(el => newSelected.includes(el.id));
        const totalSoldQty = selectedBatches.reduce(
            (sum, el) => sum + parseFloat(el?.soldQuantity || 0),
            0
        );

        if (totalSoldQty > limit) {
            const remainingQty = limit - totalSoldQty; // Ex: -20 - (-10) = -10

            const newBatch = batch.map(el => {
                if (el.id === id) {
                    if (isChecked) {
                        const available = parseFloat(el?.availableStock || 0); // negative
                        const assignQty = Math.max(available, remainingQty); // most negative value
                        return { ...el, soldQuantity: assignQty };
                    } else {
                        return { ...el, soldQuantity: el.originalSoldQuantity };
                    }
                }
                return el;
            });

            setBatch(newBatch);
            return true;
        }

        // Limit reached or exceeded
        return false;
    };


    const isSelected = (id) => selectedBatchId.indexOf(id) !== -1;

    const handleTaxCode = (data) => {
        setTaxCodeId(data?.id);
        const value = (assessableValue * (data.percentage || 0)) / 100;
        setTax(value);
    }

    const handleBulkClick = (value) => {
        if (batch?.length) {
            batch.map((el, i) => {
                el.soldQuantity = 0;
                el.originalSoldQuantity = 0;
                batch.splice(i, 1, el);
            })
        }
        if (value) {
            if (creditNote) {
                setBatch(findCombinationCredit(batch.filter(el => el.locationId === lineLocationId), lineQuantity).updatedItems);
                setSelectedBatchId(findCombinationCredit(batch.filter(el => el.locationId === lineLocationId), lineQuantity).changedItems);
            } else {
                setBatch(findCombination(batch.filter(el => el.locationId === lineLocationId), lineQuantity).updatedItems);
                setSelectedBatchId(findCombination(batch.filter(el => el.locationId === lineLocationId), lineQuantity).changedItems);
            }
        } else {
            const newBatch = batch.map(el => {
                return { ...el, soldQuantity: el.originalSoldQuantity };
            });
            setBatch(newBatch.filter(el => el.locationId === lineLocationId));
            setSelectedBatchId([]);
        }
    }

    const findCombinationCredit = (items, lineQuantity) => {
        let updatedItems = items.map(item => ({ ...item }));
        let changedItems = [];

        for (let item of updatedItems) {
            if (lineQuantity > 0) break;

            let sellQty = Math.max((item?.availableStock || 0), lineQuantity);
            if (sellQty < 0) {
                item.soldQuantity -= sellQty;
                lineQuantity += sellQty;
                item.soldQuantity = -item.soldQuantity;
                changedItems.push(item.id); // Collect updated item
            }
        }

        return { updatedItems, changedItems };
    }

    const findCombination = (items, lineQuantity) => {
        let updatedItems = items.map(item => ({ ...item }));
        let changedItems = [];

        for (let item of updatedItems) {
            if (lineQuantity <= 0) break;

            let sellQty = Math.min((item?.availableStock || 0), lineQuantity);
            if (sellQty > 0) {
                item.soldQuantity += sellQty;
                lineQuantity -= sellQty;
                changedItems.push(item.id); // Collect updated item
            }
        }

        return { updatedItems, changedItems };
    }

    const updateSoldQty = (newSelected, id, isChecked) => {
        let fBatch = batch.filter(el => newSelected.includes(el.id));
        let sQuantity = fBatch.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.soldQuantity || 0), 0);
        if (sQuantity < Math.abs(lineQuantity)) {
            let qty = Math.abs(lineQuantity) - sQuantity;
            const newBatch = batch.map(el => {
                if (el.id === id) {
                    if (isChecked) {
                        // Checked: add availableQty
                        return { ...el, soldQuantity: el.availableStock < qty ? ((el?.soldQuantity || 0) + (el?.availableStock || 0)) : qty };
                    } else {
                        // UnChecked: revert to originalSoldQty
                        return { ...el, soldQuantity: el.originalSoldQuantity };
                    }
                }
                return el;
            });
            setBatch(newBatch);
            return true;
        }
        return false
    };

    const calculateProfit = () => {
        let a = '';
        if (lineAmount && lineQuantity && lineCostPrice) {
            a = `₹ ${currencyFormat((lineAmount / lineQuantity) - lineCostPrice)}`
        }
        return a;
    }

    const handleLineDiscountRateChange = (value) => {
        let va = value < 0 ? 0 : value;
        setLineDiscountRate(va);
        if (lineDiscountType === 'perUnit') {
            setLineDiscountAmount(parseFloat(parseFloat(va * (lineQuantity || 0)).toFixed(2)));
        }
    }

    const checkZeroGstLines = (lines) => {
        const zeroGstIds = new Set(productGstdetails && productGstdetails.filter(gst => gst.percentage === 0).map(gst => gst.id));
        const matchedLine = lines.find(line => zeroGstIds.has(line.productGstId) && line.includeGst);
        return matchedLine?.productGstId ? true : false;
    }

    // --- Stable props for the hot (customer & product) dropdowns, so React.memo on
    // AutoCompleteComponent can skip re-rendering them when unrelated form state changes. ---
    const stableChangeCustomer = useStableCallback(changeCustomer);
    const stableCustomerApi = useStableCallback(customerApi);
    const stableHandleProductChange = useStableCallback(handleProductChange);
    const stableHandleProductTextChange = useStableCallback(handleProductTextChange);
    const stableProductApi = useStableCallback(productApi);
    const customerNameLabel = useMemo(
        () => ["Customer Name ", <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>],
        [classes.colorRedRequired]
    );
    const productHeads = showNameDesc === 'name' ? PRODUCT_HEADS_NAME : PRODUCT_HEADS_DESC;

    // Derived dropdown option lists, memoized so their reference is stable (an inline
    // .filter()/`|| []` would allocate a new array each render and defeat the memoized dropdown).
    const activeTeam = useMemo(() => (getTeamData || []).filter(el => el.status === 'ACTIVE'), [getTeamData]);
    const tcsOptions = useMemo(() => (otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), [otherTaxesdetails]);
    const cashDiscountOptions = useMemo(() => cashDiscountDetails || [], [cashDiscountDetails]);
    const unitOptions = useMemo(
        () => (parameterDetails?.inventoryTransaction ? units : unitMesurementdetails),
        [parameterDetails, units, unitMesurementdetails]
    );

    // Name labels that embed JSX (a required asterisk), memoized for a stable reference.
    const currencyNameLabel = useMemo(() => ["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const stateNameLabel = useMemo(() => ["State/Province - Place of Supply ", <span key={"State/Province - Place of Supply"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const pincodeNameLabel = useMemo(() => ["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);
    const unitNameLabel = useMemo(() => ["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>], [classes.colorRedRequired]);

    // Stable handlers for the remaining dropdowns so React.memo on AutoCompleteComponent can
    // skip them when unrelated state changes. useStableCallback always invokes the latest closure.
    const stableBillFormatPreviewApi = useStableCallback((data) => { setBillFormat(data.id); handlePreviewApi(); });
    const stableBillFormatPreview = useStableCallback((data) => { setBillFormat(data.id); handlePreview(); });
    const stableSalesRepChange = useStableCallback((data) => { setSalesRepId(data.id); });
    const stableSalesRepText = useStableCallback((value) => { if (value === '') { setSalesRepId(''); } });
    const stableRoundOff = useStableCallback((data) => handleRoundOff(data));
    const stableCashDiscountChange = useStableCallback((data) => setCashDiscountId(data.id));
    const stableTaxCodeChange = useStableCallback((data) => handleTaxCode(data));
    const stableTcsChange = useStableCallback((data) => setTcsNameId(data?.id));
    const stableMopChange = useStableCallback((data) => setMopId(data.id));
    const stableCurrencyChange = useStableCallback((data) => setCurrencyId(data.id));
    const stableStateChange = useStableCallback((data) => changeState(data.id));
    const stableCountryChange = useStableCallback((data) => handleChangeCountry(data.id));
    const stablePincodeChange = useStableCallback((data) => changePincode(data.id));
    const stableCityChange = useStableCallback((data) => changeCity(data.id));
    const stableAreaChange = useStableCallback((data) => { changeArea(data.id); });
    const stableGstCodeChange = useStableCallback((data) => setGstCodeId(data.id));
    const stableLineUnitChange = useStableCallback((data) => handleLineUnit(data));
    const stableLocationChange = useStableCallback(async (data) => {
        setLineLocationId(data.id);
        let batch = await getProductBatch(lineProductId);
        getAvailableQty(lineProductId, lineUnitId, data.id, batch, false, lineEdit);
    });
    const stableLocationApi = useStableCallback((s) => locationApi(s));
    const stableLineProductGstChange = useStableCallback((data) => setLineProductGstId(data.id));
    const stableLineHsnChange = useStableCallback((data) => changeLineHsn(data.id));
    const stableHsnApi = useStableCallback((s) => hsnApi(s));

    return (
        <React.Fragment>
            <MainHeader  {...props} cls={'newImg'}
                img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Sales Bill', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={`Create ${type === 'self-bill' ? 'Sales Bill' : 'Credit Note'}`}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={false}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                <Box
                                    className={clsx(classes.removeUnderline, classes.positionRelative)}
                                    component="form"
                                    autoComplete="off"
                                    onSubmit={(e) => handleSubmit(e, 'CREATED')}>
                                    {
                                        commonError && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.marginBottom20)} />
                                        </Col>
                                    }
                                    <div className={classes.tabWrapSubmit}>
                                        <Space direction="horizontal" align="center" size={[10, 10]}>
                                            {
                                                roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Invoice Template') &&
                                                <div className={classes.templateView} >
                                                    <NavLink to="#" onClick={() => handlePreviewApi()} tabIndex={-1}>
                                                        <Image tabIndex={-1} className={""} src={ViewIcon} preview={false} />
                                                        <span className={classes.customerInvoiceNone}>Invoice Template</span>
                                                    </NavLink>
                                                    <AutoCompleteComponent
                                                        name={""}
                                                        id={idNamingConversion('billFormat', 'salesBill', 'DropDown')}
                                                        heads={HEADS_LABEL}
                                                        details={templateType}
                                                        parentValue={customObject(templateType, billFormat)}
                                                        onChange={stableBillFormatPreviewApi}
                                                        position={'bottom'}
                                                        disabled={businessDetails?.taxType?.taxCode === 'COMP' ? true : false}
                                                        customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                                    />
                                                </div>
                                            }
                                            <AutoCompleteComponent
                                                name={""}
                                                placeholder={'Sales Rep'}
                                                heads={HEADS_NAME}
                                                details={activeTeam}
                                                parentValue={customObject(activeTeam, salesRepId)}
                                                onChange={stableSalesRepChange}
                                                id={idNamingConversion('Sales Rep Id', 'customerProfile', 'DropDown')}
                                                onChangeText={stableSalesRepText}
                                                position={"bottom"}
                                                customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                            />
                                            <div className={classes.templateView} >
                                                <NavLink to="#" onClick={() => handlePreview()} tabIndex={-1}>
                                                    <Image tabIndex={-1} className={""} src={ViewIcon} preview={false} />
                                                    <span className={classes.customerInvoiceNone}>Invoice Template</span>
                                                </NavLink>
                                                <AutoCompleteComponent
                                                    name={""}
                                                    id={idNamingConversion('billFormat', 'salesBill', 'DropDown')}
                                                    heads={HEADS_LABEL}
                                                    details={templateType}
                                                    parentValue={customObject(templateType, billFormat)}
                                                    onChange={stableBillFormatPreview}
                                                    position={'bottom'}
                                                    disabled={businessDetails?.taxType?.taxCode === 'COMP' ? true : false}
                                                    customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                                />
                                            </div>
                                            {
                                                roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Confirm') &&
                                                <Button
                                                    tabIndex={-1}
                                                    key="confirm"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={() => handleConfirmSubmit()}
                                                    id={idNamingConversion('Confirm', 'salesBill', 'Button')}
                                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader || pdfLoader }, { [classes.disabled]: lines.length === 0 })}
                                                >Confirm</Button>
                                            }
                                            <Button
                                                tabIndex={-1}
                                                key="save"
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Save', 'salesBill', 'Button')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader || pdfLoader })}
                                            >Save</Button>
                                        </Space>
                                    </div>
                                    <div className={classes.tabDesign}>
                                        <TabContext value={value}>
                                            <TabList onChange={(event, newValue) => handleChange(newValue)}>
                                                <Tab className={classes.Bordertab_1} label="Line View" value={"lineView"} />
                                                <Tab className={classes.Bordertab_2} label="Header View" value={"headerView"} />
                                            </TabList>
                                            <TabPanel value={"lineView"}>
                                                <Row>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                                    </Col>
                                                </Row>
                                                <Row gutter={50}>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                                                <Row gutter={10}>
                                                                    <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>SB. Number</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>---</Typography>
                                                                    </Col>
                                                                    {
                                                                        prefix ? <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                                                            <TextField autoComplete='one-time-code'
                                                                                label={["Inv. Number ", <span key={"Manual Invoice Number"} className={classes.colorRedRequired}> *</span>]}
                                                                                fullWidth
                                                                                placeholder={'Enter Manual Invoice Number'}
                                                                                name={"invoiceNumber"}
                                                                                id={idNamingConversion('Manual Invoice Number', 'salesBill', 'TextField')}
                                                                                error={errorInvoiceNumber ? true : false}
                                                                                helperText={errorInvoiceNumber}
                                                                                variant={'standard'}
                                                                                value={invoiceNumber || ''}
                                                                                InputProps={{
                                                                                    classes: {
                                                                                        input: classes.textFieldColor
                                                                                    }
                                                                                }}
                                                                                className={classes.margin20t}
                                                                                InputLabelProps={{
                                                                                    className: classes.textFieldLableColorCustom,
                                                                                    shrink: true
                                                                                }}
                                                                                onChange={(e) => setInvoiceNumber(e.target.value)}
                                                                            />
                                                                        </Col> : ''
                                                                    }
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={65} sm={12} xs={12}>
                                                                <Row>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{customerSerialNo !== null && customerSerialNo !== '' ? customerSerialNo : '---'}</Typography>
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} className={classes.textAlignRight}>
                                                                        <span className={clsx(classes.statusButton, classes.margin20t)}>{capitalizeFirstLetter('CREATED')}</span>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <FormControlLabel
                                                                    classes={{
                                                                        label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                                    }}
                                                                    control={<Switch size='small'
                                                                        className={clsx(classes.customSwitch)}
                                                                        onChange={(e) => { setInAppTransition(!inAppTransition); }}
                                                                    />}
                                                                    id={idNamingConversion('In-AppTransactions', 'salesBill', 'Radio')}
                                                                    label="In-AppTransactions"
                                                                    labelPlacement="top"
                                                                    checked={inAppTransition}
                                                                    disabled={inAppStatus === 'ACCEPTED' ? false : true}
                                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                                />
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <FormControlLabel
                                                                    classes={{
                                                                        label: clsx(classes.fonSize13)
                                                                    }}
                                                                    control={<Switch size='small'
                                                                        className={clsx(classes.customSwitch)}
                                                                        onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                                        checked={priceIncludesTax || false}
                                                                    />}
                                                                    id={idNamingConversion('Price Includes Tax', 'salesBill', 'Radio')}
                                                                    label="Price Includes Tax"
                                                                    labelPlacement="top"
                                                                    disabled={lines?.length > 0 ? true : false}
                                                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                                />
                                                            </Col>
                                                            <Col xxl={4} xl={4} lg={4} md={24} sm={24} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label={["Reference"]}
                                                                    fullWidth
                                                                    name={"reference"}
                                                                    id={idNamingConversion('Reference', 'salesBill', 'TextField')}
                                                                    error={errorRef ? true : false}
                                                                    helperText={errorRef}
                                                                    className={classes.margin20t}
                                                                    variant={'standard'}
                                                                    value={reference || ''}
                                                                    inputProps={{ maxLength: 30 }}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor
                                                                        },

                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom
                                                                    }}
                                                                    onChange={(e) => setReference(e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={customerNameLabel}
                                                                    heads={CUSTOMER_HEADS}
                                                                    details={customerDetails}
                                                                    id={idNamingConversion('Customer Name', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(customerDetails, customerId)}
                                                                    onChange={stableChangeCustomer}
                                                                    searchType={stableCustomerApi}
                                                                    parentError={errorCustomerId}
                                                                    position={"bottom"}
                                                                    customClasses={classes.margin20t}
                                                                />
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                                                    fullWidth
                                                                    // type="number"
                                                                    id={idNamingConversion('Phone Number', 'salesBill', 'TextField')}
                                                                    className={clsx(classes.margin20t)}
                                                                    error={errorMobile ? true : false}
                                                                    helperText={errorMobile}
                                                                    variant={'standard'}
                                                                    value={mobile}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom
                                                                    }}
                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Created By</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'----'}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <div className={clsx(classes.margin20t, classes.dateAdjust)} tabIndex={-1}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            value={invoiceDate}
                                                                            minDate={transactionDate}
                                                                            //maxDate={new Date(y, m + 1, 0)}
                                                                            label="Invoice Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                }
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    error: errorInvoiceDate ? true : false,
                                                                                    helperText: errorInvoiceDate,
                                                                                    id: idNamingConversion('Invoice Date', 'salesBill', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                            //readOnly={true}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue, newError) => {
                                                                                if (newError?.validationError || newValue === null) {
                                                                                    setInvoiceDate(new Date())
                                                                                } else {
                                                                                    setInvoiceDate(newValue)
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                            <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                                <div className={clsx(classes.dateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            className={clsx(classes.margin20t)}
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            minDate={new Date(invoiceDate)}
                                                                            allowKeyboardControl={false}
                                                                            value={dueDate}
                                                                            label="Due Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor
                                                                                },
                                                                                inputProps: { value: moment(dueDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    error: errorDueDate ? true : false,
                                                                                    helperText: errorDueDate,
                                                                                    id: idNamingConversion('Due Date', 'salesBill', 'TextField')
                                                                                },
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue, newError) => {
                                                                                if (newError?.validationError || newValue === null) {
                                                                                    setDueDate(new Date());
                                                                                } else {
                                                                                    setDueDate(newValue);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                                                            </Col>
                                                            {parameterDetails?.salesValue &&
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Total</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(lines.length > 0 ? lines?.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.salesValue || 0), 0) : 0)}</Typography>
                                                                </Col>
                                                            }
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(totalDiscount)}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(netAmount)}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                                    <span>GST Amount </span>
                                                                    <Tooltip tabIndex={-1}
                                                                        classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                                        title={'Rounded to 2 decimal places'} arrow placement="top"
                                                                        className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                                        <IconButton>
                                                                            <Image src={infoMarkIcon} preview={false} />
                                                                        </IconButton>
                                                                    </Tooltip></Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(gstAmount)}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Row>
                                                                    <Col xxl={6} xl={6} lg={10} md={10} sm={6} xs={6}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_ROUND_OFF}
                                                                            heads={HEADS_NAME}
                                                                            details={ROUNDOFF_OPTIONS}
                                                                            id={idNamingConversion('Round off', 'salesBill', 'DropDown')}
                                                                            parentValue={customObject(ROUNDOFF_OPTIONS, roundOffMethod)}
                                                                            onChange={stableRoundOff}
                                                                            position={"bottom"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={18} xl={18} lg={14} md={14} sm={18} xs={18}>
                                                                        <TextField autoComplete='one-time-code'
                                                                            label={[""]}
                                                                            fullWidth
                                                                            type="number"
                                                                            id={idNamingConversion('Round Off Amount', 'salesBill', 'TextField')}
                                                                            className={clsx(classes.margin20t)}
                                                                            error={errorRoundOffAmount ? true : false}
                                                                            helperText={errorRoundOffAmount}
                                                                            variant={'standard'}
                                                                            value={roundOffAmount}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: clsx(classes.textFieldColor, classes.padding10L)
                                                                                }
                                                                            }}
                                                                            inputProps={{
                                                                                step: "any",
                                                                                "aria-autocomplete": "none"
                                                                            }}
                                                                            InputLabelProps={{
                                                                                className: classes.textFieldLableColorCustom
                                                                            }}
                                                                            disabled={roundOffMethod ? false : true}
                                                                            onChange={(e) => { setRoundOffAmount(e.target.value); setTotal(parseFloat(parseFloat(totalInvoice + parseFloat(e?.target?.value || 0)).toFixed(2))); }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Amount </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(total)}</Typography>
                                                            </Col>

                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Row gutter={20}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_CASH_DISCOUNT}
                                                                            heads={HEADS_CODE}
                                                                            details={cashDiscountOptions}
                                                                            id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                                            parentValue={customObject(cashDiscountOptions, cashDiscountId)}
                                                                            onChange={stableCashDiscountChange}
                                                                            position={"top"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Amount</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(cashDiscountAmount || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(excisesAmount || 0)}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Assessable Value </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(assessableValue || 0)}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                                <Row gutter={20}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_TAX_CODE}
                                                                            heads={HEADS_CODE}
                                                                            details={taxCodedetails}
                                                                            id={idNamingConversion('Tax Code', 'salesBill', 'DropDown')}
                                                                            parentValue={customObject(taxCodedetails, taxCodeId)}
                                                                            onChange={stableTaxCodeChange}
                                                                            position={"bottom"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tax || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                                <Row gutter={20}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_TCS}
                                                                            heads={HEADS_NAME}
                                                                            details={tcsOptions}
                                                                            id={idNamingConversion('TCS', 'salesBill', 'DropDown')}
                                                                            parentValue={customObject(tcsOptions, tcsNameId)}
                                                                            onChange={stableTcsChange}
                                                                            position={"bottom"}
                                                                            disabled={!customerDetail?.tcsBoolean}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>TCS</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tcs || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </TabPanel>
                                            <TabPanel value={"headerView"}>
                                                <Row gutter={50} className={classes.mobileViewSalesState}>
                                                    <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <Row>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Bill Number</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>SB --- </Typography>

                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                                                        <span className={clsx(classes.statusButton, classes.margin20t)}>{capitalizeFirstLetter('CREATED')}</span>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <FormControlLabel
                                                                    classes={{
                                                                        label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                                    }}
                                                                    control={<Switch size='small'
                                                                        className={clsx(classes.customSwitch)}
                                                                        onChange={(e) => { setInAppTransition(!inAppTransition); }}
                                                                    />}
                                                                    id={idNamingConversion('In-AppTransactions', 'salesBill', 'Radio')}
                                                                    label="In-AppTransactions"
                                                                    labelPlacement="top"
                                                                    checked={inAppTransition}
                                                                    disabled={inAppStatus === 'ACCEPTED' ? false : true}
                                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <FormControlLabel
                                                                    classes={{
                                                                        label: clsx(classes.fonSize13)
                                                                    }}
                                                                    control={<Switch size='small'
                                                                        className={clsx(classes.customSwitch)}
                                                                        onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                                        checked={priceIncludesTax || false}
                                                                    />}
                                                                    id={idNamingConversion('Price Includes Tax', 'salesBill', 'Radio')}
                                                                    label="Price Includes Tax"
                                                                    labelPlacement="top"
                                                                    disabled={lines?.length > 0 ? true : false}
                                                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={customerNameLabel}
                                                                    heads={CUSTOMER_HEADS}
                                                                    details={customerDetails}
                                                                    id={idNamingConversion('Customer Name', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(customerDetails, customerId)}
                                                                    onChange={stableChangeCustomer}
                                                                    searchType={stableCustomerApi}
                                                                    parentError={errorCustomerId}
                                                                    position={"bottom"}
                                                                    customClasses={classes.margin20t}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} >
                                                                <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</InputLabel>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{customerSerialNo !== null && customerSerialNo !== '' ? customerSerialNo : '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter('CREATED')}</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                                                    <LocalizationProvider
                                                                        // id={idNamingConversion('Transaction Date', 'salesBill', 'TextField')}
                                                                        dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            tabIndex={-1}
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            //id={idNamingConversion('Transaction Date', 'salesBill', 'TextField')}
                                                                            views={['year', 'month', 'day']}
                                                                            value={transactionDate || null}
                                                                            label="Transaction Date"
                                                                            PopperProps={{
                                                                                className: classes.dateAdjust,
                                                                            }}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                }
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('Transaction Date', 'salesBill', 'TextField'),
                                                                                    autoComplete: 'one-time-code',
                                                                                    disabled: true,
                                                                                    value: transactionDate || null
                                                                                },
                                                                            }}
                                                                            // minDate={new Date(y, m, 1)}
                                                                            // maxDate={new Date(y, m + 1, 0)}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue, newError) => {
                                                                                setDateChange(newValue);
                                                                                // if (newError?.validationError || newValue === null) {
                                                                                //     //setDateChange(new Date());
                                                                                //     setTransactionDate(new Date())
                                                                                // } else {
                                                                                //     // setDateChange(newValue);
                                                                                //     setTransactionDate(newValue)
                                                                                // }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <div className={clsx(classes.margin20t, classes.dateAdjust)} tabIndex={-1}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            value={invoiceDate}
                                                                            minDate={transactionDate}
                                                                            //maxDate={new Date(y, m + 1, 0)}
                                                                            label="Invoice Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                }
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    error: errorInvoiceDate ? true : false,
                                                                                    helperText: errorInvoiceDate,
                                                                                    id: idNamingConversion('Invoice Date', 'salesBill', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                            //readOnly={true}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue, newError) => {
                                                                                if (newError?.validationError || newValue === null) {
                                                                                    setInvoiceDate(new Date())
                                                                                } else {
                                                                                    setInvoiceDate(newValue)
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                                                    fullWidth
                                                                    // type="number"
                                                                    id={idNamingConversion('Phone Number', 'salesBill', 'TextField')}
                                                                    className={clsx(classes.margin20t)}
                                                                    error={errorMobile ? true : false}
                                                                    helperText={errorMobile}
                                                                    variant={'standard'}
                                                                    value={mobile}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom
                                                                    }}
                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={NAME_MOP}
                                                                    heads={MOP_HEADS}
                                                                    details={mopDetails}
                                                                    id={idNamingConversion('Method of Payment (MOP)', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(mopDetails, mopId)}
                                                                    onChange={stableMopChange}
                                                                    position={"bottom"}
                                                                    customClasses={classes.margin20t}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={currencyNameLabel}
                                                                    heads={CURRENCY_HEADS}
                                                                    details={currencyDetails}
                                                                    id={idNamingConversion('Currency', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(currencyDetails, currencyId)}
                                                                    onChange={stableCurrencyChange}
                                                                    parentError={errorCurrency}
                                                                    position={"top"}
                                                                    customClasses={classes.margin20t}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label={'Email'}
                                                                    fullWidth
                                                                    className={clsx(classes.margin20t)}
                                                                    variant={'standard'}
                                                                    id={idNamingConversion('Email', 'salesBill', 'TextField')}
                                                                    error={errorEmail ? true : false}
                                                                    helperText={errorEmail}
                                                                    value={email}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom,
                                                                    }}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <Row gutter={0}>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        <div className={clsx(classes.margin20t, classes.dateAdjust)} tabIndex={-1}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    fullWidth
                                                                                    slots={{
                                                                                        openPickerIcon: DateIcon
                                                                                    }}
                                                                                    views={['year', 'month', 'day']}
                                                                                    value={fromDate}
                                                                                    label="Service From Date"
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor,
                                                                                        }
                                                                                    }}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            id: idNamingConversion('Service From Date', 'salesBill', 'TextField'),
                                                                                            autoComplete: 'one-time-code'
                                                                                        },
                                                                                    }}
                                                                                    //readOnly={true}
                                                                                    format="dd/MM/yyyy"
                                                                                    onChange={(newValue, newError) => {
                                                                                        if (newError?.validationError || newValue === null) {
                                                                                            setFromDate(new Date())
                                                                                        } else {
                                                                                            setFromDate(newValue);
                                                                                        }
                                                                                        setToDate(null);
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                        <div className={clsx(classes.margin20t, classes.dateAdjust, classes.dateAdjustToDate)} tabIndex={-1}>
                                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                <DesktopDatePicker
                                                                                    fullWidth
                                                                                    slots={{
                                                                                        openPickerIcon: DateIcon
                                                                                    }}
                                                                                    views={['year', 'month', 'day']}
                                                                                    value={toDate}
                                                                                    minDate={fromDate}
                                                                                    disabled={fromDate ? false : true}
                                                                                    label="Service To Date"
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: classes.textFieldColor,
                                                                                        }
                                                                                    }}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            id: idNamingConversion('Service To Date', 'salesBill', 'TextField'),
                                                                                            autoComplete: 'one-time-code'
                                                                                        },
                                                                                    }}
                                                                                    //readOnly={true}
                                                                                    format="dd/MM/yyyy"
                                                                                    onChange={(newValue, newError) => {
                                                                                        if (newError?.validationError || newValue === null) {
                                                                                            setToDate(fromDate)
                                                                                        } else {
                                                                                            setToDate(newValue)
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label={["Reference"]}
                                                                    fullWidth
                                                                    name={"reference"}
                                                                    id={idNamingConversion('Reference', 'salesBill', 'TextField')}
                                                                    className={clsx(classes.margin20t)}
                                                                    error={errorRef ? true : false}
                                                                    helperText={errorRef}
                                                                    variant={'standard'}
                                                                    value={reference || ''}
                                                                    inputProps={{ maxLength: 30 }}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom
                                                                    }}
                                                                    onChange={(e) => setReference(e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label={["Dispatch Details"]}
                                                                    fullWidth
                                                                    name={"dispatchDetails"}
                                                                    id={idNamingConversion('Dispatch Details', 'salesBill', 'TextField')}
                                                                    className={clsx(classes.margin20t)}
                                                                    variant={'standard'}
                                                                    value={dispatchDetails || ''}
                                                                    inputProps={{ maxLength: 50 }}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom
                                                                    }}
                                                                    onChange={(e) => setDispatchDetails(e.target.value)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                                                        <Row gutter={50} className={clsx(classes.mobileViewSalesCreate)}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} style={{ height: 40 }} className={clsx(classes.typographyHeader, classes.typographyHeaderToolTip, classes.bold)}><span>Address</span>
                                                                    <Tooltip
                                                                        classes={{ popper: classes.customToolTip }}
                                                                        title={'The Address selected here will determine the Tax Applicable'} arrow placement="top" className={classes.tooltip}>
                                                                        <IconButton>
                                                                            <Image src={infoMarkIcon} preview={false} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Typography>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={stateNameLabel}
                                                                    heads={STATE_HEADS}
                                                                    details={stateDetails}
                                                                    id={idNamingConversion('State', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(stateDetails, stateId)}
                                                                    onChange={stableStateChange}
                                                                    position={"bottom"}
                                                                    customClasses={clsx(classes.margin10t)}
                                                                    parentError={errorState}
                                                                />
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={NAME_COUNTRY}
                                                                    heads={COUNTRY_HEADS}
                                                                    details={countryDetails}
                                                                    id={idNamingConversion('Country', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(countryDetails, countryId)}
                                                                    onChange={stableCountryChange}
                                                                    position={"bottom"}
                                                                    customClasses={classes.margin10t}
                                                                />
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={pincodeNameLabel}
                                                                    heads={PINCODE_HEADS}
                                                                    details={pincodeDetails}
                                                                    id={idNamingConversion('Pincode', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(pincodeDetails, pincodeId)}
                                                                    onChange={stablePincodeChange}
                                                                    position={"bottom"}
                                                                    customClasses={classes.margin20t}
                                                                    parentError={errorPincode}
                                                                />
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={NAME_CITY}
                                                                    heads={CITY_HEADS}
                                                                    details={cityDetails}
                                                                    id={idNamingConversion('City', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(cityDetails, cityId)}
                                                                    onChange={stableCityChange}
                                                                    position={"top"}
                                                                    customClasses={classes.margin20t}
                                                                />
                                                            </Col>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={NAME_AREA}
                                                                    heads={AREA_HEADS}
                                                                    details={areaDetails}
                                                                    id={idNamingConversion('Area', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(areaDetails, areaId)}
                                                                    onChange={stableAreaChange}
                                                                    position={"top"}
                                                                    customClasses={classes.margin20t}
                                                                    customLink={'/admin/address/area'}
                                                                    linkText={'Go to Area'}
                                                                    infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                                />
                                                            </Col>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.mobileAreaAddress)}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label=''
                                                                    placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                                    value={address || ''}
                                                                    variant={'outlined'}
                                                                    className={clsx(classes.customDescription, classes.margin30t)}
                                                                    fullWidth
                                                                    multiline
                                                                    rows={3}
                                                                    name={"address"}
                                                                    id={idNamingConversion('Address', 'salesBill', 'DropDown')}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor,
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom,
                                                                    }}
                                                                    onChange={(e) => setAddress(e.target.value)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row gutter={50}>
                                                    <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.margin35t, classes.bold)}>GST Details</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <FormControlLabel
                                                                    classes={{
                                                                        label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                                                    }}
                                                                    id={idNamingConversion('Tax Invoice', 'salesBill', 'Radio')}
                                                                    control={<Switch size='small'
                                                                        className={clsx(classes.customSwitch)}
                                                                        onChange={(e) => handleIncludeGst(!includeGst)}
                                                                    />}
                                                                    label="Tax Invoice"
                                                                    labelPlacement="top"
                                                                    checked={includeGst}
                                                                    disabled={includeDisabled}
                                                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <AutoCompleteComponent
                                                                    name={NAME_PARTY_GST}
                                                                    heads={PARTY_GST_HEADS}
                                                                    details={partyGstdetails}
                                                                    id={idNamingConversion('Party GST Code', 'salesBill', 'DropDown')}
                                                                    parentValue={customObject(partyGstdetails, gstCodeId)}
                                                                    onChange={stableGstCodeChange}
                                                                    parentError={errorGstCode}
                                                                    position={"top"}
                                                                    customClasses={clsx(classes.margin20t)}
                                                                />
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                                <div className={clsx(classes.dateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            className={clsx(classes.margin20t)}
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            minDate={new Date(invoiceDate)}
                                                                            allowKeyboardControl={false}
                                                                            value={dueDate}
                                                                            label="Due Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor
                                                                                },
                                                                                inputProps: { value: moment(dueDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    error: errorDueDate && true,
                                                                                    helperText: errorDueDate,
                                                                                    id: idNamingConversion('Due Date', 'salesBill', 'TextField')
                                                                                },
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue, newError) => {
                                                                                if (newError?.validationError || newValue === null) {
                                                                                    setDueDate(new Date());
                                                                                } else {
                                                                                    setDueDate(newValue);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xxl={8} xl={8} lg={8} md={16} sm={24} xs={24}>
                                                        <Row gutter={50} className={clsx(classes.mobileViewSalesCreate)}>
                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.mobileAreaAddress)}>
                                                                <TextField autoComplete='one-time-code'
                                                                    label=''
                                                                    placeholder='Comments'
                                                                    value={comments || ''}
                                                                    variant={'outlined'}
                                                                    className={clsx(classes.customDescription, classes.margin30t)}
                                                                    fullWidth
                                                                    multiline
                                                                    rows={3}
                                                                    name={"comments"}
                                                                    inputProps={{ maxLength: 120 }}
                                                                    id={idNamingConversion('Comments', 'salesBill', 'DropDown')}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor,
                                                                        }
                                                                    }}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom,
                                                                    }}
                                                                    onChange={(e) => setComments(e.target.value)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row gutter={50}>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                                                    </Col>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Total</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(lines.length > 0 ? lines?.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.salesValue || 0), 0) : 0)}</Typography>
                                                    </Col>
                                                </Row>
                                                <Row gutter={50}>
                                                    <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹  {currencyFormat(totalDiscount)}</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(netAmount)}</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                                    <span>GST Amount </span>
                                                                    <Tooltip tabIndex={-1}
                                                                        classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                                        title={'Rounded to 2 decimal places'} arrow placement="top"
                                                                        className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                                        <IconButton>
                                                                            <Image src={infoMarkIcon} preview={false} />
                                                                        </IconButton>
                                                                    </Tooltip> </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(gstAmount)}</Typography>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xxl={8} xl={8} lg={8} md={16} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                                                                <Row>
                                                                    <Col xxl={8} xl={10} lg={10} md={8} sm={6} xs={6}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_ROUND_OFF}
                                                                            heads={HEADS_NAME}
                                                                            details={ROUNDOFF_OPTIONS}
                                                                            id={idNamingConversion('Round off', 'salesBill', 'DropDown')}
                                                                            parentValue={customObject(ROUNDOFF_OPTIONS, roundOffMethod)}
                                                                            onChange={stableRoundOff}
                                                                            position={"bottom"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={16} xl={14} lg={14} md={16} sm={18} xs={18}>
                                                                        <TextField autoComplete='one-time-code'
                                                                            label={[""]}
                                                                            fullWidth
                                                                            type="number"
                                                                            id={idNamingConversion('Round Off Amount', 'salesBill', 'TextField')}
                                                                            className={clsx(classes.margin20t)}
                                                                            error={errorRoundOffAmount ? true : false}
                                                                            helperText={errorRoundOffAmount}
                                                                            variant={'standard'}
                                                                            value={roundOffAmount}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: clsx(classes.textFieldColor, classes.padding10L)
                                                                                }
                                                                            }}
                                                                            inputProps={{
                                                                                step: "any"
                                                                            }}
                                                                            InputLabelProps={{
                                                                                className: classes.textFieldLableColorCustom
                                                                            }}
                                                                            disabled={roundOffMethod ? false : true}
                                                                            onChange={(e) => { setRoundOffAmount(e.target.value); setTotal(parseFloat(parseFloat(totalInvoice + parseFloat(e?.target?.value || 0)).toFixed(2))); }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={16} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Amount </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(total)}</Typography>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row gutter={50}>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                                    </Col>
                                                </Row>
                                                <Row gutter={50}>
                                                    <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                <Row gutter={20}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_CASH_DISCOUNT}
                                                                            heads={HEADS_CODE}
                                                                            details={cashDiscountOptions}
                                                                            id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                                            parentValue={customObject(cashDiscountOptions, cashDiscountId)}
                                                                            onChange={stableCashDiscountChange}
                                                                            position={"top"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Amount</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(cashDiscountAmount || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(excisesAmount || 0)}</Typography>
                                                            </Col>
                                                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Assessable Value </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(assessableValue || 0)}</Typography>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xxl={8} xl={8} lg={8} md={16} sm={24} xs={24}>
                                                        <Row gutter={50}>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                                                                <Row gutter={20}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_TAX_CODE}
                                                                            heads={HEADS_CODE}
                                                                            details={taxCodedetails}
                                                                            id={idNamingConversion('Tax Code', 'salesBill', 'DropDown')}
                                                                            parentValue={customObject(taxCodedetails, taxCodeId)}
                                                                            onChange={stableTaxCodeChange}
                                                                            position={"bottom"}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tax || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                                                                <Row gutter={20}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                                                        <AutoCompleteComponent
                                                                            name={NAME_TCS}
                                                                            heads={HEADS_NAME}
                                                                            details={tcsOptions}
                                                                            id={idNamingConversion('TCS', 'salesBill', 'DropDown')}
                                                                            parentValue={customObject(tcsOptions, tcsNameId)}
                                                                            onChange={stableTcsChange}
                                                                            position={"bottom"}
                                                                            disabled={!customerDetail?.tcsBoolean}
                                                                            customClasses={classes.margin20t}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>TCS</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(tcs || 0)}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </TabPanel>
                                        </TabContext>
                                    </div>
                                </Box>
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Sales Bill Lines'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={pincodeLoader && selfBillCustomerId}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignRight}>
                                        <Space direction="horizontal" align="center" size={[10, 10]}>
                                            {
                                                roleManagement !== '' && checkComponentPermission('Sales Bill', 'Page', 'Add Products') && customerId &&
                                                <NavLink to={'#'} id={idNamingConversion('Add Products', 'salesBill', 'Link')} onClick={() => handleCustomerProductsOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Products</span>
                                                </NavLink>
                                            }
                                            {
                                                customerId &&
                                                <NavLink to={'#'} id={idNamingConversion('Add Lines', 'salesBill', 'Link')} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </Col>
                                </Row>
                                <div className={clsx(classes.tableRoot)}>
                                    <CustomInfiniteScroll
                                        loadMore={true}
                                        loadMoreContent={false}
                                        heads={billLineHead}
                                        width={true}
                                        component={
                                            <>
                                                {
                                                    lines.length > 0 && lines.map((data, i) => {
                                                        let code = productGstdetails && productGstdetails?.find(el => el.id === data.productGstId);
                                                        return (
                                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} className={clsx({[classes.listItemStatic]:data?.includeGst && code?.percentage === 0})} style={{ backgroundColor: data?.includeGst && code?.percentage === 0 ? "#fff2e4" : "transparent" }}>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 0) }}><span style={{ width: getColumnWidth(billLineHead, 0) }}>{i + 1}</span></TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 1) }}>
                                                                    {
                                                                        data?.parentLineNumber ? <NavLink style={{ width: getColumnWidth(billLineHead, 1) }} to={"#"}
                                                                            className={clsx(classes.bold, classes.color)}><span className={classes.descEllipsis}>{data.description}</span>
                                                                        </NavLink> : <NavLink style={{ width: getColumnWidth(billLineHead, 1) }} to={"#"}
                                                                            className={clsx(classes.bold, classes.color)}
                                                                            onClick={() => onView(data, i)}><span className={classes.descEllipsis}>{data.description}</span>
                                                                        </NavLink>
                                                                    }
                                                                </TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 2) }}><span style={{ width: getColumnWidth(billLineHead, 2) }}>{data.quantity ? data.quantity : '---'}</span></TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 3) }}>
                                                                    <span style={{ width: getColumnWidth(billLineHead, 4) }}> {
                                                                        unitMesurementdetails && unitMesurementdetails.length > 0 && unitMesurementdetails.filter(unitMesurementdetail => unitMesurementdetail.id === data.unitId).map(filteredUnit => (
                                                                            <React.Fragment key={filteredUnit.id}>
                                                                                {filteredUnit.name}
                                                                            </React.Fragment>
                                                                        ))
                                                                    }</span>
                                                                </TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 5) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 5) }}>{`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}</span></TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 6) }}>
                                                                    {`₹ ${(data.discountAmount || data.discountPercent) ?
                                                                        (data.quantity < 0 ?
                                                                            currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * (data?.discountPercent || 0)) / 100))) :
                                                                            currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * (data?.discountPercent || 0)) / 100))))
                                                                        : currencyFormat(0)}`}
                                                                </span>
                                                                </TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 7) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 8) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 8) }}>{`₹ ${currencyFormat(data?.excisesTotal || 0)}`}</span></TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 9) }}><span style={{ width: getColumnWidth(billLineHead, 9) }}>{data.productGstId ? (
                                                                    productGstdetails && productGstdetails.length > 0 && productGstdetails.filter(productGstdetail => productGstdetail.id === data.productGstId).map(filteredGst => (
                                                                        <React.Fragment key={filteredGst.id}>
                                                                            {filteredGst.code}
                                                                        </React.Fragment>
                                                                    )))
                                                                    : '---'}</span></TableCell>
                                                                <TableCell style={{ width: getColumnWidth(billLineHead, 9) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(billLineHead, 9) }}>₹ {data.gstAmount ? currencyFormat(data.gstAmount) : '0.00'}</span></TableCell>
                                                                <TableCell className={classes.textAlignRight}>
                                                                    {
                                                                        data?.parentLineNumber ? '' : <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                                            <NavLink to={"#"} onClick={() => onView(data, i)}>
                                                                                <Image
                                                                                    src={ViewIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                            <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                                                <Image
                                                                                    src={EditIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                            <NavLink to={"#"} onClick={() => onDelete(data, i)}>
                                                                                <Image
                                                                                    src={DeleteIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                        </Space>
                                                                    }

                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                }
                                                {
                                                    lines.length === 0 && (
                                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell style={{ textAlign: "center" }} colSpan={10}>
                                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Bill'}</p>

                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            </>
                                        }
                                    />
                                </div>
                            </>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
            <FreeProduct
                open={showFreeProduct}
                handleClose={() => setShowFreeProduct(!showFreeProduct)}
                Row={Row}
                Col={Col}
                Box={Box}
                clsx={clsx}
                classes={classes}
                Typography={Typography}
                freeProduct={freeProduct}
                freeBatch={freeBatch}
                lineLocationId={lineLocationId}
                moment={moment}
                freeAvailableQuantity={freeAvailableQuantity}
                errorBatchQuantity={errorFreeBatchQuantity}
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                width={'690px'}
                title={primaryTitle + ' Sales Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete='off'
                        onSubmit={(e) => handleLineSubmit(e)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={30}>
                                <Col style={{ position: "relative" }} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)} style={{ paddingTop: 2 }}>Line {lineNumber} Details {freeProduct?.id && <NavLink className={classes.freeProduct} onClick={() => setShowFreeProduct(!showFreeProduct)} to={'#'}>Free Product</NavLink>}</Typography>
                                    <FormControl
                                        style={{ position: "absolute", right: 10, top: 0, alignItems: "end", width: "50%" }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={showNameDesc}
                                            onChange={(e) => {
                                                storageSetItem('billProductView', e.target.value);
                                                setShowNameDesc(e.target.value);
                                            }}>
                                            <FormControlLabel value="name" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Name" />
                                            <FormControlLabel value="description" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Description" />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <div className={classes.positionRelative}>
                                        {
                                            lineCostPrice ? <div className={clsx(classes.infoSuggestion, classes.infoSuggestionPos)}>
                                                <img alt="Cost Price" src={InfoMark} /> <span>Cost Price - {lineCostPrice}</span></div> : ''
                                        }
                                        <AutoCompleteComponent
                                            name={`Product (Optional) ${lineProductId ? (
                                                myProductdetails && myProductdetails.length > 0
                                                    ? '- ' + myProductdetails.find(mP => mP.id === lineProductId)?.productId ?? "---"
                                                    : "---"
                                            ) : "---"}`}
                                            heads={productHeads}
                                            details={myProductdetails}
                                            id={idNamingConversion('Product', 'salesBillLine', 'DropDown')}
                                            parentValue={customObject(myProductdetails, lineProductId)}
                                            onChange={stableHandleProductChange}
                                            onChangeText={stableHandleProductTextChange}
                                            position={"bottom"}
                                            disabled={lineLocationId ? false : true}
                                            searchType={stableProductApi}
                                            customClasses={classes.margin10t}
                                        />
                                    </div>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <InputLabel error={errorLineDescription ? true : false} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')}>Description <span key={"Description"} className={classes.colorRedRequired}> *</span></InputLabel>
                                    <TextField autoComplete='one-time-code'
                                        maxRows={2}
                                        fullWidth
                                        className={clsx(classes.textAreaAdjust)}
                                        multiline={true}
                                        value={lineDescription}
                                        error={errorLineDescription ? true : false}
                                        helperText={errorLineDescription}
                                        id={idNamingConversion('Description', 'salesBillLine', 'TextField')}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textAreaLableColorCustom,
                                        }}
                                        onChange={(e) => { setLineDescription(e.target.value) }}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                        label={["Quantity ", <span key={"Quantity"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        value={lineQuantity}
                                        id={idNamingConversion('Quantity', 'salesBillLine', 'TextField')}
                                        error={errorLineQuantity ? true : false}
                                        helperText={errorLineQuantity}
                                        fullWidth
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            },
                                            endAdornment: availableQuantity !== '' && parameterDetails?.inventoryTransaction ?
                                                <InputAdornment className={clsx(classes.lastSalesPrice)} position="end">
                                                    <div className={classes.infoSuggestion}><img alt="Avl Qty" src={InfoMark} /> <span>Avl Qty- {availableQuantity}</span></div></InputAdornment>
                                                : false

                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        inputProps={{
                                            step: "any"
                                        }}
                                        onChange={(e) => {
                                            handleQuantityChange(e.target.value);
                                            if (e.target.value !== '') {
                                                if (!creditNote && e.target.value < 0) {
                                                    setLineQuantity(e.target.value = 0)
                                                } else if (creditNote && e.target.value >= 0) {
                                                    setLineQuantity(-(e.target.value))
                                                } else {
                                                    setLineQuantity(e.target.value)
                                                }
                                            } else {
                                                setLineQuantity(e.target.value)
                                            }
                                        }}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <AutoCompleteComponent
                                        name={unitNameLabel}
                                        heads={UNIT_HEADS}
                                        details={unitOptions}
                                        parentValue={customObject(unitOptions, lineUnitId)}
                                        id={idNamingConversion('Unit', 'salesBillLine', 'DropDown')}
                                        onChange={stableLineUnitChange}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                        parentError={errorLineUnitId}
                                        infoMark={lineStock?.unitId && lineStock?.unitId !== lineUnitId ? `${lineStock?.quantity} - ${lineStock?.unit?.name} ` : false}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <div className={classes.customUnitPrice}>
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Unit Price ", <span key={"Unit Price"} className={classes.colorRedRequired}> *</span>]}
                                            type={'number'}
                                            variant={'standard'}
                                            id={idNamingConversion('Unit Price', 'salesBillLine', 'TextField')}
                                            error={errorLinePrice ? true : false}
                                            helperText={errorLinePrice}
                                            value={linePrice}
                                            fullWidth
                                            onKeyDown={(e) => shouldBlur(e)}
                                            onWheel={(e) => e.target.blur()}
                                            InputProps={{
                                                startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">₹ </InputAdornment>,
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                endAdornment: parameterDetails?.lastSalesPrice && productPrices?.lastprice && !unitPriceList && lineProductId && linePrice &&
                                                    linePrice === productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name]?.price ?
                                                    <InputAdornment className={clsx(classes.lastSalesPrice)} position="end">
                                                        <div className={classes.infoSuggestion}><img alt="Last Sales Price" src={InfoMark} /> <span>Last Sales Price</span></div></InputAdornment>
                                                    : false
                                            }}
                                            inputProps={{
                                                step: "any"
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onFocus={() => setUnitPriceFocusList(true)}
                                            onChange={(e) =>
                                                e.target.value !== '' ?
                                                    e.target.value < 0 ?
                                                        setLinePrice((e.target.value = 0)) : setLinePrice(e.target.value) : setLinePrice(e.target.value)}
                                        />

                                        {
                                            parameterDetails?.lastSalesPrice && productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 && unitPriceFocusList && lineProductId && <div className={classes.suggestionBox}>
                                                <CloseIcon onClick={() => setUnitPriceFocusList(false)} className={classes.productpriceCloseIcon} />
                                                <div className={classes.suggestionBoxTitle}><div className={classes.infoSuggestion}><img alt="Last Sales Price" src={InfoMark} /> <span>Last Sales Price</span></div></div>
                                                <div className={classes.historicalData}>
                                                    {
                                                        productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 && Object?.entries(productPrices?.lastprice)?.map(([key, value]) => (
                                                            <NavLink to="#" onClick={() => handleProductPrice(key)} key={key}>₹ {value?.price} per {key}</NavLink>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Row>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineMrp ? '₹ ' + currencyFormat(lineMrp || 0) : '---'}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} style={{ textAlign: "right" }}>
                                            {parameterDetails?.salesValue && <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Value</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSalesValue ? '₹ ' + currencyFormat(lineSalesValue || 0) : '---'}</Typography>
                                            </>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30} align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Line Amount</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'₹ ' + currencyFormat(lineAmount || 0)}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row align="bottom">
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    {
                                                        roleManagement !== '' && checkComponentPermission('Sales Bill', 'Page', 'Profit') && <>
                                                            {
                                                                calculateProfit() && <>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Profit</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{calculateProfit()}</Typography>
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </Col>
                                                {
                                                    parameterDetails?.inventoryTransaction && <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <NavLink
                                                            to="#"
                                                            id={idNamingConversion('View Batch', 'salesBillLine', 'Link')}
                                                            onClick={() => setViewBatch(!viewBatch)}
                                                            className={clsx(classes.customLink, classes.textAlignRight)}>
                                                            <Image
                                                                src={ViewIcon}
                                                                preview={false}
                                                                className={clsx(classes.antImage, classes.padding10Left)}
                                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Batch</span>
                                                        </NavLink>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    viewBatch && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row align="bottom">
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Batch Details</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} style={{ textAlign: "right" }}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                    }}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => { setAutoMark(!autoMark); handleBulkClick(e.target.checked) }}
                                                    />}
                                                    id={idNamingConversion('Auto Mark', 'salesBillLine', 'Radio')}
                                                    label="Auto Mark"
                                                    labelPlacement="top"
                                                    checked={autoMark}
                                                    className={clsx(classes.marginLeft0, classes.flexStart)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <div className={classes.tablecontainBatchSales}>
                                                    <TableContainer className={clsx(classes.tablecontain, classes.tablecontainBatch)}>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell className={clsx(classes.tablealign)}>
                                                                        <Checkbox onChange={(e) => handleBulkClick(e.target.checked)} />
                                                                    </TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Batch ID</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Qty</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Line Qty</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>MRP</TableCell>
                                                                    {
                                                                        parameterDetails?.salesBatchDiscount && <TableCell className={clsx(classes.tablealign)}>Disc.Amt</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.tablealign)}>Mfg Date</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.tablealign)}>Expiry Date</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.tablealign)}>Use By | Best Before</TableCell>}
                                                                </TableRow>
                                                            </TableHead>

                                                            {
                                                                batch?.length > 0 && batch.filter(el => el.locationId === lineLocationId).length > 0 ? batch.filter(el => el.locationId === lineLocationId).map((data, i) => (
                                                                    <TableRow id={'tableRow_' + i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell)}><Checkbox checked={isSelected(data.id)} onChange={(e) => handleClick(data.id)} /> </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.batchNumber || ''} </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.availableStock || ''} </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.soldQuantity || 0} </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.mrp || 0} </TableCell>
                                                                        {
                                                                            parameterDetails?.salesBatchDiscount && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                                                <TextField autoComplete='one-time-code'
                                                                                    fullWidth
                                                                                    style={{ width: 80 }}
                                                                                    className={clsx(classes.batchTextField)}
                                                                                    value={data?.discountAmount || ''}
                                                                                    type={'number'}
                                                                                    InputProps={{
                                                                                        classes: {
                                                                                            input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                                        }
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                        className: classes.textAreaLableColorCustom,
                                                                                    }}
                                                                                    inputProps={{
                                                                                        step: "any"
                                                                                    }}
                                                                                    disabled={isSelected(data.id) ? false : true}
                                                                                    id={idNamingConversion('Discount_' + i, 'purchaseBill', 'TextField')}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    onFocus={(e) => e.target.select()}
                                                                                    onChange={(e) => {
                                                                                        if (e.target.value < 0) {
                                                                                            changeHandlerBatch(data, e.target.value = 0, 'discountAmount')
                                                                                        } else {
                                                                                            changeHandlerBatch(data, e.target.value, 'discountAmount')
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                        }
                                                                        {
                                                                            parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.manufacturingDate ? moment(data?.manufacturingDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                        {
                                                                            parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.expiryDate ? moment(data?.expiryDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                        {
                                                                            parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.useByDate ? moment(data?.useByDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                    </TableRow>
                                                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                    <TableCell colSpan={8} className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>No Batch Found</TableCell>
                                                                </TableRow>
                                                            }
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                                {
                                                    errorBatchQuantity && <p style={{ color: "red", margin: "5px 0 0 0" }}>{errorBatchQuantity}</p>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Discount Details</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                        label='Discount %'
                                        title={'Enter discount in Percentage'}
                                        variant={'standard'}
                                        type={'number'}
                                        id={idNamingConversion('Discount', 'salesBillLine', 'TextField')}
                                        error={lineDiscountPercentage && errorDiscountAgreements ? true : false}
                                        helperText={lineDiscountPercentage && errorDiscountAgreements ? errorDiscountAgreements : ''}
                                        value={lineDiscountPercentage}
                                        fullWidth
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineDiscountPercentage((e.target.value = 0)) : setLineDiscountPercentage(e.target.value) : setLineDiscountPercentage(e.target.value)}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        <span>Calculated discount amount</span>
                                        <Tooltip
                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountPercAmount ? '₹ ' + currencyFormat(lineDiscountPercAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30} align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row gutter={30} align="bottom">
                                                {
                                                    parameterDetails?.discountRate ? <>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Type</Typography>
                                                            <FormControl
                                                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                                variant={'standard'}
                                                                fullWidth>
                                                                <RadioGroup
                                                                    row
                                                                    value={lineDiscountType}
                                                                    onChange={(e) => {
                                                                        setLineDiscountType(e.target.value);
                                                                        setLineDiscountRate('');
                                                                        setLineDiscountAmount('');
                                                                    }}>
                                                                    <FormControlLabel value="perUnit" control={<Radio
                                                                        checkedIcon={<UnSelectedIcon />}
                                                                        icon={<SelectedIcon />}
                                                                    />} label="Per Unit" />
                                                                    <FormControlLabel value="fixed" control={<Radio
                                                                        checkedIcon={<UnSelectedIcon />}
                                                                        icon={<SelectedIcon />}
                                                                    />} label="Fixed" />
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Col>
                                                        {
                                                            lineDiscountType === 'perUnit' ? <>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <TextField autoComplete='one-time-code'
                                                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                                                        label='Discount Rate / Unit'
                                                                        variant={'standard'}
                                                                        title={'Enter Discount Rate / Unit'}
                                                                        type={'number'}
                                                                        id={idNamingConversion('Discount Rate / Unit', 'salesBillLine', 'TextField')}
                                                                        value={lineDiscountRate}
                                                                        fullWidth
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: classes.textFieldColor,
                                                                            }
                                                                        }}
                                                                        inputProps={{
                                                                            step: "any"
                                                                        }}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        InputLabelProps={{
                                                                            className: classes.textFieldLableColorCustom,
                                                                        }}
                                                                        onChange={(e) => handleLineDiscountRateChange(e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                                        <span>Discount Amount</span></Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                                </Col>
                                                            </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <TextField autoComplete='one-time-code'
                                                                    className={clsx(classes.margin20t, classes.removeUnderline)}
                                                                    label='Discount Amount'
                                                                    variant={'standard'}
                                                                    title={'Enter discount in Amount'}
                                                                    type={'number'}
                                                                    id={idNamingConversion('Discount Amount', 'salesBillLine', 'TextField')}
                                                                    error={lineDiscountAmount && errorDiscountAgreements ? true : false}
                                                                    helperText={lineDiscountAmount && errorDiscountAgreements ? errorDiscountAgreements : ''}
                                                                    value={lineDiscountAmount}
                                                                    fullWidth
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: classes.textFieldColor,
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        step: "any"
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    InputLabelProps={{
                                                                        className: classes.textFieldLableColorCustom,
                                                                    }}
                                                                    onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineDiscountAmount((e.target.value = 0)) : setLineDiscountAmount(e.target.value) : setLineDiscountAmount(e.target.value)}
                                                                />
                                                            </Col>
                                                        }
                                                    </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <TextField autoComplete='one-time-code'
                                                            className={clsx(classes.margin20t, classes.removeUnderline)}
                                                            label='Discount Amount'
                                                            variant={'standard'}
                                                            title={'Enter discount in Amount'}
                                                            type={'number'}
                                                            id={idNamingConversion('Discount Amount', 'salesBillLine', 'TextField')}
                                                            error={lineDiscountAmount && errorDiscountAgreements ? true : false}
                                                            helperText={lineDiscountAmount && errorDiscountAgreements ? errorDiscountAgreements : ''}
                                                            value={lineDiscountAmount}
                                                            fullWidth
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColorCustom,
                                                            }}
                                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineDiscountAmount((e.target.value = 0)) : setLineDiscountAmount(e.target.value) : setLineDiscountAmount(e.target.value)}
                                                        />
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                <span>Total Discount Amount</span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                    title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountCalcAmount ? '₹ ' + currencyFormat(lineDiscountCalcAmount) : '---'}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Row gutter={30}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Location</Typography>
                                                </Col>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={NAME_LOCATION}
                                                        heads={LOCATION_HEADS}
                                                        details={locationDetails}
                                                        id={idNamingConversion('Location', 'salesBillLine', 'DropDown')}
                                                        parentValue={customObject(locationDetails, lineLocationId)}
                                                        onChange={stableLocationChange}
                                                        position={"bottom"}
                                                        searchType={stableLocationApi}
                                                        customClasses={classes.margin10t}
                                                        reset={false}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    lineExcisesApplicable && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row gutter={30}>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Total</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise</Typography>
                                                <FormControl
                                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <RadioGroup
                                                        row
                                                        value={lineExcisesType}
                                                        onChange={(e) => {
                                                            setLineExcisesType(e.target.value);
                                                        }}>
                                                        <FormControlLabel value="perUnit" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Per Unit" />
                                                        <FormControlLabel value="fixed" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Fixed" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Total</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineExcisesTotal || 0}</Typography>
                                            </Col>
                                            {
                                                lineExcisesType === 'perUnit' ? <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <TextField autoComplete='one-time-code'
                                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                                        label='Excise Rate / Unit'
                                                        variant={'standard'}
                                                        title={'Enter Excise Rate / Unit'}
                                                        type={'number'}
                                                        id={idNamingConversion('Excise Rate / Unit', 'salesBillLine', 'TextField')}
                                                        error={errorLineExcisesAmount ? true : false}
                                                        helperText={errorLineExcisesAmount ? errorLineExcisesAmount : ''}
                                                        value={lineExcisesRate}
                                                        fullWidth
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        onWheel={(e) => e.target.blur()}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineExcisesRate((e.target.value = 0)) : setLineExcisesRate(e.target.value) : setLineExcisesRate(e.target.value)}
                                                    />
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineExcisesAmount || 0}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <TextField autoComplete='one-time-code'
                                                            className={clsx(classes.margin20t, classes.removeUnderline)}
                                                            label='Excise Amount'
                                                            variant={'standard'}
                                                            title={'Enter Excise Amount'}
                                                            type={'number'}
                                                            id={idNamingConversion('Excise Amount', 'salesBillLine', 'TextField')}
                                                            error={errorLineExcisesAmount ? true : false}
                                                            helperText={errorLineExcisesAmount ? errorLineExcisesAmount : ''}
                                                            value={lineExcisesAmount}
                                                            fullWidth
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColorCustom,
                                                            }}
                                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineExcisesAmount((e.target.value = 0)) : setLineExcisesAmount(e.target.value) : setLineExcisesAmount(e.target.value)}
                                                        />
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise</Typography>
                                                <FormControl
                                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <RadioGroup
                                                        row
                                                        value={lineSplExcisesType}
                                                        onChange={(e) => {
                                                            setLineSplExcisesType(e.target.value);
                                                        }}>
                                                        <FormControlLabel value="perUnit" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Per Unit" />
                                                        <FormControlLabel value="fixed" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Fixed" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col>
                                            {
                                                lineSplExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <TextField autoComplete='one-time-code'
                                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                                        label='SPL Excise Rate / Unit'
                                                        variant={'standard'}
                                                        title={'Enter SPL Excise Rate / Unit'}
                                                        type={'number'}
                                                        id={idNamingConversion('Excise SPL Rate / Unit', 'salesBillLine', 'TextField')}
                                                        error={errorLineSplExcisesAmount ? true : false}
                                                        helperText={errorLineSplExcisesAmount ? errorLineSplExcisesAmount : ''}
                                                        value={lineSplExcisesRate}
                                                        fullWidth
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        onWheel={(e) => e.target.blur()}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineSplExcisesRate((e.target.value = 0)) : setLineSplExcisesRate(e.target.value) : setLineSplExcisesRate(e.target.value)}
                                                    />
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSplExcisesAmount || 0}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <TextField autoComplete='one-time-code'
                                                            className={clsx(classes.margin20t, classes.removeUnderline)}
                                                            label='SPL Excise Amount'
                                                            variant={'standard'}
                                                            title={'Enter SPL Excise Amount'}
                                                            type={'number'}
                                                            id={idNamingConversion('SPL Excise Amount', 'salesBillLine', 'TextField')}
                                                            value={lineSplExcisesAmount}
                                                            error={errorLineSplExcisesAmount ? true : false}
                                                            helperText={errorLineSplExcisesAmount ? errorLineSplExcisesAmount : ''}
                                                            fullWidth
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            inputProps={{
                                                                step: "any"
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColorCustom,
                                                            }}
                                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineSplExcisesAmount((e.target.value = 0)) : setLineSplExcisesAmount(e.target.value) : setLineSplExcisesAmount(e.target.value)}
                                                        />
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <TextField autoComplete='one-time-code'
                                                    className={clsx(classes.margin20t, classes.removeUnderline)}
                                                    label='Additional Excise Amount'
                                                    variant={'standard'}
                                                    title={'Enter Additional Excise Amount'}
                                                    type={'number'}
                                                    id={idNamingConversion('Additional Excise Amount', 'salesBillLine', 'TextField')}
                                                    value={lineAddExcisesAmount}
                                                    fullWidth
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    inputProps={{
                                                        step: "any"
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineAddExcisesAmount((e.target.value = 0)) : setLineAddExcisesAmount(e.target.value) : setLineAddExcisesAmount(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Line Amount</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{currencyFormat(lineTotalCostPrice || 0)}</Typography>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details </Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')
                                                }}
                                                id={idNamingConversion('Tax Invoice', 'salesBillLine', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => handleLineIncludeGst(!lineIncludeGst)}
                                                    checked={lineIncludeGst}
                                                />}
                                                label="Tax Invoice"
                                                labelPlacement="top"
                                                disabled={!includeGst || (!lineProductGstId && lineExcisesApplicable)}
                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Row gutter={30}>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={NAME_PRODUCT_GST}
                                                        heads={PRODUCT_GST_HEADS}
                                                        details={productGstdetails}
                                                        id={idNamingConversion('Product GST Code', 'salesBillLine', 'DropDown')}
                                                        parentValue={customObject(productGstdetails, lineProductGstId)}
                                                        onChange={stableLineProductGstChange}
                                                        parentError={errorLineProductGst}
                                                        position={"top"}
                                                        topPosition={true}
                                                        disabled={!lineIncludeGst}
                                                        customClasses={classes.margin20t}
                                                    />
                                                </Col>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CGST</Typography>
                                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineCgst ? lineCgst + '%' : '---'} - {lineCgst && lineCgstAmount ? '₹ ' + currencyFormat(lineCgstAmount) : '---'}</Typography>
                                                </Col>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={NAME_HSN}
                                                        heads={HSN_HEADS}
                                                        details={hsnDetails}
                                                        id={idNamingConversion('HSN Code', 'salesBillLine', 'DropDown')}
                                                        parentError={errorLineHsn}
                                                        parentValue={customObject(hsnDetails, lineHsnId)}
                                                        onChange={stableLineHsnChange}
                                                        position={"top"}
                                                        searchType={stableHsnApi}
                                                        topPosition={true}
                                                        customClasses={classes.margin20t}
                                                    />
                                                </Col>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SGST / UTGST</Typography>
                                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSgst ? lineSgst + '%' : '---'} - {lineSgst && lineSgstAmount ? '₹ ' + currencyFormat(lineSgstAmount) : '---'}</Typography>
                                                </Col>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst}
                                                        className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                        <span>GST Amount </span>
                                                        <span><Tooltip
                                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                            <IconButton>
                                                                <Image src={infoMarkIcon} preview={false} />
                                                            </IconButton>
                                                        </Tooltip></span>
                                                    </Typography>
                                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineGstAmount ? '₹ ' + currencyFormat(lineGstAmount || 0) : '---'}</Typography>
                                                </Col>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IGST</Typography>
                                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineIgst ? lineIgst + '%' : '---'} - {lineIgst ? lineIgstAmount ? '₹ ' + currencyFormat(lineIgstAmount) : '---' : '---'}</Typography>
                                                </Col>
                                            </Row>
                                        </Col>

                                        { /* <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>CESS Details </Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["GST CESS Type"]}
                                                heads={[{ 'key': 'label', 'name': 'Type' }]}
                                                details={[
                                                    { id: 'PERCENTAGE', label: 'Percentage' },
                                                    { id: 'AMOUNT', label: 'Amount' }
                                                ]}
                                                id={idNamingConversion('GST CESS Type', 'salesBillLine', 'DropDown')}
                                                parentValue={customObject([
                                                    { id: 'PERCENTAGE', label: 'Percentage' },
                                                    { id: 'AMOUNT', label: 'Amount' }
                                                ], lineCessType)}
                                                onChange={(data) => setLineCessType(data.id)}
                                                position={"top"}
                                                topPosition={true}
                                                disabled={!lineIncludeGst}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                className={clsx(classes.margin20t, classes.removeUnderline)}
                                                label='CESS Rate'
                                                title={`Enter CESS Rate in ${lineCessType}`}
                                                variant={'standard'}
                                                type={'number'}
                                                id={idNamingConversion('CESS Rate', 'salesBillLine', 'TextField')}
                                                value={lineCessValue}
                                                fullWidth
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setLineCessValue((e.target.value = 0)) : setLineCessValue(e.target.value) : setLineCessValue(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CESS Amount</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'₹ ' + currencyFormat(lineCessAmount || 0)}</Typography>
                                        </Col> */}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                {
                                    primaryTitle === 'Add' && <Button
                                        key="add"
                                        color='primary'
                                        id={idNamingConversion('Add More', 'salesBillLine', 'Button')}
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: stockLoading })}
                                        onClick={(e) => handleAddMore(e)}
                                    >Add More</Button>
                                }
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    id={idNamingConversion('Save', 'salesBillLine', 'Button')}
                                    className={clsx(classes.modalBtn, { [classes.loading]: stockLoading })}>
                                    {primaryTitle === 'Add' ? 'Save' : 'Update'}
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />

            <PrimaryDrawer
                anchor={'right'}
                open={viewVisible}
                variant={'temporary'}
                handleClose={() => handleViewClose()}
                width={'690px'}
                title={'View Sales Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box className={clsx(classes.customForm, classes.removeUnderline)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={30}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin10t, classes.typographyHeader, classes.bold)}>Line {lineNumber} Details</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product {lineProductId ? (
                                        myProductdetails && myProductdetails.length > 0 &&
                                        myProductdetails.filter(mP => mP.id === lineProductId).map(filteredProducts => (
                                            <React.Fragment key={filteredProducts?.id}>
                                                {'- ' + filteredProducts?.productId}
                                            </React.Fragment>
                                        )))
                                        : ''}</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {lineProductId ? (
                                            myProductdetails && myProductdetails.length > 0 &&
                                            myProductdetails.filter(mP => mP.id === lineProductId).map(filteredProducts => (
                                                <React.Fragment key={filteredProducts?.id}>
                                                    {filteredProducts?.productName}
                                                </React.Fragment>
                                            )))
                                            : '---'}
                                        {
                                            lineCostPrice ? <div className={clsx(classes.infoSuggestion, classes.infoSuggestionPos)}>
                                                <img alt="Cost Price" src={InfoMark} /> <span>Cost Price - {lineCostPrice}</span></div> : ''
                                        }
                                    </Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}><span className={classes.descEllipsis}>{lineDescription ? lineDescription : '---'}</span></Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Quantity</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineQuantity ? lineQuantity : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Unit</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{
                                        unitMesurementdetails && unitMesurementdetails.length > 0 && unitMesurementdetails.filter(unitMesurementdetail => unitMesurementdetail.id === lineUnitId).map(filteredUnit => (
                                            <React.Fragment key={filteredUnit.id}>
                                                {filteredUnit.name}
                                            </React.Fragment>
                                        ))
                                    }</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom, classes.fonSize13)}>Unit Price</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{linePrice ? '₹ ' + currencyFormat(linePrice) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Row>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}><span className={classes.descEllipsis}>{lineMrp ? '₹ ' + currencyFormat(lineMrp) : '---'}</span></Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} style={{ textAlign: "right" }}>
                                            {parameterDetails?.salesValue && <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Value</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSalesValue ? '₹ ' + currencyFormat(lineSalesValue || 0) : '---'}</Typography>
                                            </>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30} align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom, classes.fonSize13)}>Line Amount</Typography>
                                            <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineAmount ? '₹ ' + lineAmount.toFixed(2) : '---'}</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row align="bottom">
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    {
                                                        roleManagement !== '' && checkComponentPermission('Sales Bill', 'Page', 'Profit') && <>
                                                            {
                                                                calculateProfit() && <>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Profit</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{calculateProfit()}</Typography>
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </Col>
                                                {
                                                    parameterDetails?.inventoryTransaction &&
                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <NavLink
                                                            to="#"
                                                            id={idNamingConversion('View Batch', 'salesBillLine', 'Link')}
                                                            onClick={() => setViewBatch(!viewBatch)}
                                                            className={clsx(classes.customLink, classes.textAlignRight)}>
                                                            <Image
                                                                src={ViewIcon}
                                                                preview={false}
                                                                className={clsx(classes.antImage, classes.padding10Left)}
                                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>View Batch</span>
                                                        </NavLink>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    viewBatch && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row align="bottom">
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Batch Details</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <div className={classes.tablecontainBatchSales}>
                                                    <TableContainer className={clsx(classes.tablecontain, classes.tablecontainBatch)}>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell className={clsx(classes.tablealign)}>Batch ID</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Qty</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>Line Qty</TableCell>
                                                                    <TableCell className={clsx(classes.tablealign)}>MRP</TableCell>
                                                                    {
                                                                        parameterDetails?.salesBatchDiscount && <TableCell className={clsx(classes.tablealign)}>Disc.Amt</TableCell>
                                                                    }
                                                                    {
                                                                        parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.tablealign)}>Mfg Date</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.tablealign)}>Expiry Date</TableCell>}
                                                                    {
                                                                        parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.tablealign)}>Use By | Best Before</TableCell>}
                                                                </TableRow>
                                                            </TableHead>
                                                            {
                                                                batch?.length > 0 ? batch.map((data, i) => (
                                                                    <TableRow id={'tableRow_' + i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.batchNumber || ''} </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.availableStock || ''} </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.soldQuantity || 0} </TableCell>
                                                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.mrp || 0} </TableCell>
                                                                        {
                                                                            parameterDetails?.salesBatchDiscount && <TableCell className={clsx(classes.storeSalesLineCell)}>{data?.discountAmount || 0} </TableCell>
                                                                        }
                                                                        {
                                                                            parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.manufacturingDate ? moment(data?.manufacturingDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                        {
                                                                            parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.expiryDate ? moment(data?.expiryDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                        {
                                                                            parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignLeft)}>{data?.useByDate ? moment(data?.useByDate).format('DD-MMM-YYYY') : '---'}</TableCell>}
                                                                    </TableRow>
                                                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                                    <TableCell colSpan={6} className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>No Batch Found</TableCell>
                                                                </TableRow>
                                                            }
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Discount Details</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom, classes.fonSize13)}>Discount %</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountPercentage ? lineDiscountPercentage : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        <span>Calculated discount amount</span>
                                        <Tooltip
                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountPercAmount ? '₹ ' + currencyFormat(lineDiscountPercAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30} align="bottom">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Row>
                                                {
                                                    parameterDetails?.discountRate ? <>
                                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Type</Typography>
                                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountType || '---'}</Typography>
                                                        </Col>
                                                        {
                                                            lineDiscountType === 'perUnit' ? <>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Rate / Unit </Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountRate ? '₹ ' + currencyFormat(lineDiscountRate) : '---'}</Typography>
                                                                </Col>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Amount </Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                                </Col>
                                                            </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Amount </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                            </Col>
                                                        }
                                                    </> : <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Discount Amount </Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountAmount ? '₹ ' + currencyFormat(lineDiscountAmount) : '---'}</Typography>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                <span>Total Discount Amount</span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                    title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton><Image src={infoMarkIcon} preview={false} /></IconButton>
                                                </Tooltip>
                                            </Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineDiscountCalcAmount ? '₹ ' + currencyFormat(lineDiscountCalcAmount) : '---'}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={30}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                            <Row gutter={30}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Location</Typography>
                                                </Col>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    {
                                                        lineLocationId ? locationDetails && locationDetails.length > 0 && locationDetails.filter(locationDetail => locationDetail.id === lineLocationId).map(filteredLocation => (
                                                            <React.Fragment key={filteredLocation.id}>
                                                                {filteredLocation.name}
                                                            </React.Fragment>
                                                        )) : '---'
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>
                                </Col>
                                {
                                    lineExcisesApplicable && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Row gutter={30}>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Total</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineExcisesType || '---'}</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Total</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesTotal || 0)}</Typography>
                                            </Col>
                                            {
                                                lineExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Rate / Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesRate || 0)}</Typography>
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesAmount || 0)}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineExcisesAmount || 0)}</Typography>
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSplExcisesType || '---'}</Typography>
                                            </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col>
                                            {
                                                lineSplExcisesType === 'perUnit' ? <> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Rate / Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineSplExcisesRate || 0)}</Typography>
                                                </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineSplExcisesAmount || 0)}</Typography>
                                                    </Col></> : <><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SPL Excise Amount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineSplExcisesAmount || 0)}</Typography>
                                                    </Col><Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}></Col></>
                                            }
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Additional Excise Amount</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineAddExcisesAmount || 0)}</Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Line Amount</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lineTotalCostPrice || 0)}</Typography>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details </Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin35t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax Invoice</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineIncludeGst ? 'Yes' : 'No'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Gst Code</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{
                                        lineProductGstId ? productGstdetails && productGstdetails.length > 0 && productGstdetails.filter(productGstdetail => productGstdetail.id === lineProductGstId).map(filteredGst => (
                                            <React.Fragment key={filteredGst.id}>
                                                {filteredGst.code}
                                            </React.Fragment>
                                        )) : '---'
                                    }</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CGST</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineCgst ? lineCgst + '%' : '---'} - {lineCgstAmount ? '₹ ' + currencyFormat(lineCgstAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{
                                        lineHsnId ? hsnDetails && hsnDetails.length > 0 && hsnDetails.filter(hsnDetail => hsnDetail.id === lineHsnId).map(filteredHsn => (
                                            <React.Fragment key={filteredHsn.id}>
                                                {filteredHsn.hsnCode}
                                            </React.Fragment>
                                        )) : '---'
                                    }</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SGST / UTGST</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineSgst ? lineSgst + '%' : '---'} - {lineSgstAmount ? '₹ ' + currencyFormat(lineSgstAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        <span>GST Amount </span>
                                        <Tooltip
                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                            title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineGstAmount ? '₹ ' + currencyFormat(lineGstAmount) : '---'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} disabled={!lineIncludeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IGST</Typography>
                                    <Typography variant={'h6'} disabled={!lineIncludeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineIgst ? lineIgst + '%' : '---'} - {lineIgstAmount ? '₹ ' + currencyFormat(lineIgstAmount) : '---'}</Typography>
                                </Col>

                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent, classes.bold)}>
                            <NavLink to={'#'} onClick={() => onEditButton()} className={clsx(classes.modalBtn, classes.bold, classes.marginRight0)}>Edit</NavLink>
                        </div>
                    </Box>
                }
            />
            {
                productsVisible && <CustomerProducts
                    classes={classes}
                    clsx={clsx}
                    productGstdetails={productGstdetails}
                    dispatch={dispatch}
                    handleClose={() => setProductsVisible(false)}
                    visible={productsVisible}
                    customerId={customerId}
                    includeGst={includeGst}
                    productActions={productActions}
                    businessDetails={businessDetails}
                    customerDetail={customerDetail}
                    productPrices={productPrices}
                    priceIncludesTax={priceIncludesTax}
                    hsnApi={(s = '', id = '') => hsnApi(s, id)}
                    lineSubmit={(selected) => handleBulkLineSubmit(selected)}
                    lines={lines}
                    creditNote={creditNote}
                    hsnDetails={hsnDetails}
                    locationApi={() => locationApi()}
                    locationDetails={locationDetails}
                    unitMesurementdetails={unitMesurementdetails}
                    customObject={(details, id) => customObject(details, id)}
                    emptyValidation={(name, id, type = '') => emptyValidation(name, id, type)}
                    gstCalculation={(business, details, customer) => gstCalculation(business, details, customer)}
                    customNumberValidation={(name, value) => customNumberValidation(name, value)}
                    quote={false}
                />
            }
            {
                open &&
                <InvoiceModal open={open}
                    title={downloadTitle(preview ? previewData : createData, 'sales-bill')}
                    handleClose={(o) => handleModalClose(o)}
                    link={preview ? '' : ((selfBillCustomerId && decryptedId) ? `/sales/sales-management/self-bill/${AESEncrypt(createData.id)}/${selfBillCustomerId}/view` : `/sales/sales-management/self-bill/${AESEncrypt(createData.id)}/view`)}
                    {...props}
                    type={"create"}
                    businessDetails={businessDetails}
                    proformaPreview={preview}
                    format={billFormat}
                    priceIncludesTax={priceIncludesTax}
                    details={preview ? previewData : createData} />
            }
            {
                pdfPreview &&
                <InvoicePDFViewer open={pdfPreview}
                    title={downloadTitle(preview ? previewData : createData, 'sales-bill')}
                    handleClose={(o) => setPdfPreview(o)}
                    link={preview ? '' : ((selfBillCustomerId && decryptedId) ? `/sales/sales-management/self-bill/${AESEncrypt(createData.id)}/${selfBillCustomerId}/view` : `/sales/sales-management/self-bill/${AESEncrypt(createData.id)}/view`)}
                    {...props}
                    type={"create"}
                    fileUri={pdfPreview}
                    businessDetails={businessDetails}
                    proformaPreview={preview}
                    format={billFormat}
                    priceIncludesTax={priceIncludesTax}
                    details={preview ? previewData : createData}
                />
            }
            <Modal
                title={'Delete Confirmation'}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => deleteLine()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => handleCancel()}>
                        No
                    </Button>,
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineDescription}</p>
            </Modal>
            <Modal
                title={'Warning message'}
                open={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                footer={[
                    <Space direction="horizontal" align="center">
                        <NavLink
                            to={`#`} onClick={() => handleWarningYes()}
                            className={clsx(classes.AddMoreBtn, classes.bold, classes.textAlignLeft)}
                        >Yes</NavLink>
                        <NavLink
                            to={`#`} onClick={() => setModalVisible(false)}
                            className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft)}
                        >No</NavLink>
                    </Space>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>Please note, changing the Tax Invoice to "No" should comply to GST law. Are you sure you want to continue to make this change ?</Typography>
            </Modal>
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                yesId={idNamingConversion('Confirm Yes', 'salesBill', 'Button')}
                noId={idNamingConversion('Confirm No', 'salesBill', 'Button')}
                title={'Bill Confirmation'}
                loading={createLoader}
                onOpen={() => handleCommonSubmit('CONFIRMED')}
                onClose={() => {
                    if (checkZeroGstLines(lines)) {
                        const firstItem = document.querySelector(`.${classes.listItemStatic}`);
                        if (firstItem) {
                            firstItem.scrollIntoView({ behavior: 'smooth' });
                        }
                    }
                    setConfirm(false)
                }}
                creditNote={creditNote}
                text={<p>{checkZeroGstLines(lines) ? 'Lines with zero GST have been identified. Please confirm whether you wish to proceed with these entries' : 'Are you sure do you want to Confirm the Bill?'}</p>}
            />
            <CustomModal
                visible={dateChange ? true : false}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Transaction Date'}
                loading={createLoader}
                onOpen={() => { setTransactionDate(dateChange); setDateChange(''); }}
                onClose={() => setDateChange('')}
                text={<>
                    <p>It is not recommended to change the Transaction date as it will impact GST reporting and filing of GST Invoices.</p>
                    <p>Any changes you make, please speak to your Customer about the date change and impact to GST</p>
                </>}
            />
        </React.Fragment>
    )
}
export default SelfBillsCreate